import "core-js/modules/es.array.reduce";
import _construct from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/construct";
import _toArray from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toArray";
import _slicedToArray from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e5) { throw _e5; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e6) { didErr = true; err = _e6; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import * as THREE from "three";
import mergeRefs from 'react-merge-refs';
import { ResizeObserver } from '@juggle/resize-observer';
import useMeasure from 'react-use-measure';
import { useAsset } from 'use-asset';
import { TinyEmitter } from 'tiny-emitter';
import require$$2, { unstable_now, unstable_runWithPriority, unstable_IdlePriority } from 'scheduler';
import require$$0 from 'object-assign';
import React, { createContext, useState, useRef, useCallback, useMemo, useLayoutEffect, useEffect, useContext as useContext$1 } from 'react';
import { Layers, Color, Texture, sRGBEncoding, Vector2, Raycaster, Scene, OrthographicCamera, PerspectiveCamera, Clock, Vector3, PCFSoftShadowMap, ACESFilmicToneMapping, WebGL1Renderer, WebGLRenderer } from 'three';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import _extends from '@babel/runtime/helpers/esm/extends';
/*
React v0.25.1
react-reconciler.production.min.js
Copyright (c) Facebook, Inc. and its affiliates.
This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

var Ma = function (e, k, g) {
  return g = {
    path: k,
    exports: {},
    require: function require() {
      throw Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
    }
  }, e(g, g.exports), g.exports;
}(function (e) {
  e.exports = function h(g) {
    function m(a) {
      for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) {
        b += "&args[]=" + encodeURIComponent(arguments[c]);
      }

      return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }

    function v(a) {
      if (null === a || "object" !== typeof a) return null;
      a = Td && a[Td] || a["@@iterator"];
      return "function" === typeof a ? a : null;
    }

    function y(a) {
      if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function (b) {
          0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function (b) {
          0 === a._status && (a._status = 2, a._result = b);
        });
      }
    }

    function r(a) {
      if (null == a) return null;
      if ("function" === typeof a) return a.displayName || a.name || null;
      if ("string" === typeof a) return a;

      switch (a) {
        case Na:
          return "Fragment";

        case pb:
          return "Portal";

        case Ob:
          return "Profiler";

        case Ud:
          return "StrictMode";

        case Pb:
          return "Suspense";

        case Hc:
          return "SuspenseList";
      }

      if ("object" === typeof a) switch (a.$$typeof) {
        case Vd:
          return "Context.Consumer";

        case Wd:
          return "Context.Provider";

        case Ic:
          var b = a.render;
          b = b.displayName || b.name || "";
          return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");

        case Jc:
          return r(a.type);

        case Xd:
          return r(a.render);

        case Yd:
          if (a = 1 === a._status ? a._result : null) return r(a);
      }
      return null;
    }

    function w(a) {
      var b = a,
          c = a;
      if (a.alternate) for (; b.return;) {
        b = b.return;
      } else {
        a = b;

        do {
          b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        } while (a);
      }
      return 3 === b.tag ? c : null;
    }

    function Q(a) {
      if (w(a) !== a) throw Error(m(188));
    }

    function M(a) {
      var b = a.alternate;

      if (!b) {
        b = w(a);
        if (null === b) throw Error(m(188));
        return b !== a ? null : a;
      }

      for (var c = a, d = b;;) {
        var f = c.return;
        if (null === f) break;
        var l = f.alternate;

        if (null === l) {
          d = f.return;

          if (null !== d) {
            c = d;
            continue;
          }

          break;
        }

        if (f.child === l.child) {
          for (l = f.child; l;) {
            if (l === c) return Q(f), a;
            if (l === d) return Q(f), b;
            l = l.sibling;
          }

          throw Error(m(188));
        }

        if (c.return !== d.return) c = f, d = l;else {
          for (var u = !1, e = f.child; e;) {
            if (e === c) {
              u = !0;
              c = f;
              d = l;
              break;
            }

            if (e === d) {
              u = !0;
              d = f;
              c = l;
              break;
            }

            e = e.sibling;
          }

          if (!u) {
            for (e = l.child; e;) {
              if (e === c) {
                u = !0;
                c = l;
                d = f;
                break;
              }

              if (e === d) {
                u = !0;
                d = l;
                c = f;
                break;
              }

              e = e.sibling;
            }

            if (!u) throw Error(m(189));
          }
        }
        if (c.alternate !== d) throw Error(m(190));
      }

      if (3 !== c.tag) throw Error(m(188));
      return c.stateNode.current === c ? a : b;
    }

    function ma(a) {
      a = M(a);
      if (!a) return null;

      for (var b = a;;) {
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;else {
          if (b === a) break;

          for (; !b.sibling;) {
            if (!b.return || b.return === a) return null;
            b = b.return;
          }

          b.sibling.return = b.return;
          b = b.sibling;
        }
      }

      return null;
    }

    function Da(a) {
      a = M(a);
      if (!a) return null;

      for (var b = a;;) {
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child && 4 !== b.tag) b.child.return = b, b = b.child;else {
          if (b === a) break;

          for (; !b.sibling;) {
            if (!b.return || b.return === a) return null;
            b = b.return;
          }

          b.sibling.return = b.return;
          b = b.sibling;
        }
      }

      return null;
    }

    function Ea(a) {
      var b = "";

      do {
        a: switch (a.tag) {
          case 3:
          case 4:
          case 6:
          case 7:
          case 10:
          case 9:
            var c = "";
            break a;

          default:
            var d = a._debugOwner,
                f = a._debugSource,
                l = r(a.type);
            c = null;
            d && (c = r(d.type));
            d = l;
            l = "";
            f ? l = " (at " + f.fileName.replace(Mf, "") + ":" + f.lineNumber + ")" : c && (l = " (created by " + c + ")");
            c = "\n    in " + (d || "Unknown") + l;
        }

        b += c;
        a = a.return;
      } while (a);

      return b;
    }

    function A(a) {
      0 > bb || (a.current = Kc[bb], Kc[bb] = null, bb--);
    }

    function B(a, b) {
      bb++;
      Kc[bb] = a.current;
      a.current = b;
    }

    function Z(a, b) {
      var c = a.type.contextTypes;
      if (!c) return Fa;
      var d = a.stateNode;
      if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
      var f = {},
          l;

      for (l in c) {
        f[l] = b[l];
      }

      d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = f);
      return f;
    }

    function I(a) {
      a = a.childContextTypes;
      return null !== a && void 0 !== a;
    }

    function na() {
      A(S);
      A(N);
    }

    function qb(a, b, c) {
      if (N.current !== Fa) throw Error(m(168));
      B(N, b);
      B(S, c);
    }

    function Ga(a, b, c) {
      var d = a.stateNode;
      a = b.childContextTypes;
      if ("function" !== typeof d.getChildContext) return c;
      d = d.getChildContext();

      for (var f in d) {
        if (!(f in a)) throw Error(m(108, r(b) || "Unknown", f));
      }

      return rb({}, c, {}, d);
    }

    function va(a) {
      a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Fa;
      Oa = N.current;
      B(N, a);
      B(S, S.current);
      return !0;
    }

    function sb(a, b, c) {
      var d = a.stateNode;
      if (!d) throw Error(m(169));
      c ? (a = Ga(a, b, Oa), d.__reactInternalMemoizedMergedChildContext = a, A(S), A(N), B(N, a)) : A(S);
      B(S, c);
    }

    function J() {
      switch (Nf()) {
        case Qb:
          return 99;

        case Zd:
          return 98;

        case $d:
          return 97;

        case ae:
          return 96;

        case be:
          return 95;

        default:
          throw Error(m(332));
      }
    }

    function Rb(a) {
      switch (a) {
        case 99:
          return Qb;

        case 98:
          return Zd;

        case 97:
          return $d;

        case 96:
          return ae;

        case 95:
          return be;

        default:
          throw Error(m(332));
      }
    }

    function n(a, b) {
      a = Rb(a);
      return Of(a, b);
    }

    function tb(a, b, c) {
      a = Rb(a);
      return Lc(a, b, c);
    }

    function cb(a) {
      null === wa ? (wa = [a], Sb = Lc(Qb, ub)) : wa.push(a);
      return ce;
    }

    function R() {
      if (null !== Sb) {
        var a = Sb;
        Sb = null;
        de(a);
      }

      ub();
    }

    function ub() {
      if (!Mc && null !== wa) {
        Mc = !0;
        var a = 0;

        try {
          var b = wa;
          n(99, function () {
            for (; a < b.length; a++) {
              var c = b[a];

              do {
                c = c(!0);
              } while (null !== c);
            }
          });
          wa = null;
        } catch (c) {
          throw null !== wa && (wa = wa.slice(a + 1)), Lc(Qb, R), c;
        } finally {
          Mc = !1;
        }
      }
    }

    function da(a, b, c) {
      c /= 10;
      return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
    }

    function db(a, b) {
      return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
    }

    function eb(a, b) {
      if (Pa(a, b)) return !0;
      if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
      var c = Object.keys(a),
          d = Object.keys(b);
      if (c.length !== d.length) return !1;

      for (d = 0; d < c.length; d++) {
        if (!Pf.call(b, c[d]) || !Pa(a[c[d]], b[c[d]])) return !1;
      }

      return !0;
    }

    function T(a, b) {
      if (a && a.defaultProps) {
        b = rb({}, b);
        a = a.defaultProps;

        for (var c in a) {
          void 0 === b[c] && (b[c] = a[c]);
        }
      }

      return b;
    }

    function vb(a, b) {
      a = a.type._context;
      Nc ? (B(Tb, a._currentValue), a._currentValue = b) : (B(Tb, a._currentValue2), a._currentValue2 = b);
    }

    function fb(a) {
      var b = Tb.current;
      A(Tb);
      a = a.type._context;
      Nc ? a._currentValue = b : a._currentValue2 = b;
    }

    function xa(a, b) {
      for (; null !== a;) {
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;else break;
        a = a.return;
      }
    }

    function ea(a, b) {
      gb = a;
      hb = Ha = null;
      a = a.dependencies;
      null !== a && null !== a.firstContext && (a.expirationTime >= b && (ra = !0), a.firstContext = null);
    }

    function U(a, b) {
      if (hb !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) hb = a, b = 1073741823;
        b = {
          context: a,
          observedBits: b,
          next: null
        };

        if (null === Ha) {
          if (null === gb) throw Error(m(308));
          Ha = b;
          gb.dependencies = {
            expirationTime: 0,
            firstContext: b,
            responders: null
          };
        } else Ha = Ha.next = b;
      }

      return Nc ? a._currentValue : a._currentValue2;
    }

    function p(a) {
      a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
          pending: null
        },
        effects: null
      };
    }

    function t(a, b) {
      a = a.updateQueue;
      b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
      });
    }

    function oa(a, b) {
      a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
      };
      return a.next = a;
    }

    function F(a, b) {
      a = a.updateQueue;

      if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
      }
    }

    function ee(a, b) {
      var c = a.alternate;
      null !== c && t(c, a);
      a = a.updateQueue;
      c = a.baseQueue;
      null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
    }

    function wb(a, b, c, d) {
      var f = a.updateQueue;
      Ia = !1;
      var l = f.baseQueue,
          u = f.shared.pending;

      if (null !== u) {
        if (null !== l) {
          var e = l.next;
          l.next = u.next;
          u.next = e;
        }

        l = u;
        f.shared.pending = null;
        e = a.alternate;
        null !== e && (e = e.updateQueue, null !== e && (e.baseQueue = u));
      }

      if (null !== l) {
        e = l.next;
        var g = f.baseState,
            m = 0,
            p = null,
            n = null,
            h = null;

        if (null !== e) {
          var t = e;

          do {
            u = t.expirationTime;

            if (u < d) {
              var r = {
                expirationTime: t.expirationTime,
                suspenseConfig: t.suspenseConfig,
                tag: t.tag,
                payload: t.payload,
                callback: t.callback,
                next: null
              };
              null === h ? (n = h = r, p = g) : h = h.next = r;
              u > m && (m = u);
            } else {
              null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: t.suspenseConfig,
                tag: t.tag,
                payload: t.payload,
                callback: t.callback,
                next: null
              });
              fe(u, t.suspenseConfig);

              a: {
                var q = a,
                    Oc = t;
                u = b;
                r = c;

                switch (Oc.tag) {
                  case 1:
                    q = Oc.payload;

                    if ("function" === typeof q) {
                      g = q.call(r, g, u);
                      break a;
                    }

                    g = q;
                    break a;

                  case 3:
                    q.effectTag = q.effectTag & -4097 | 64;

                  case 0:
                    q = Oc.payload;
                    u = "function" === typeof q ? q.call(r, g, u) : q;
                    if (null === u || void 0 === u) break a;
                    g = rb({}, g, u);
                    break a;

                  case 2:
                    Ia = !0;
                }
              }

              null !== t.callback && (a.effectTag |= 32, u = f.effects, null === u ? f.effects = [t] : u.push(t));
            }

            t = t.next;
            if (null === t || t === e) if (u = f.shared.pending, null === u) break;else t = l.next = u.next, u.next = e, f.baseQueue = l = u, f.shared.pending = null;
          } while (1);
        }

        null === h ? p = g : h.next = n;
        f.baseState = p;
        f.baseQueue = h;
        Ub(m);
        a.expirationTime = m;
        a.memoizedState = g;
      }
    }

    function ge(a, b, c) {
      a = b.effects;
      b.effects = null;
      if (null !== a) for (b = 0; b < a.length; b++) {
        var d = a[b],
            f = d.callback;

        if (null !== f) {
          d.callback = null;
          d = f;
          f = c;
          if ("function" !== typeof d) throw Error(m(191, d));
          d.call(f);
        }
      }
    }

    function Vb(a, b, c, d) {
      b = a.memoizedState;
      c = c(d, b);
      c = null === c || void 0 === c ? b : rb({}, b, c);
      a.memoizedState = c;
      0 === a.expirationTime && (a.updateQueue.baseState = c);
    }

    function he(a, b, c, d, f, l, u) {
      a = a.stateNode;
      return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, l, u) : b.prototype && b.prototype.isPureReactComponent ? !eb(c, d) || !eb(f, l) : !0;
    }

    function ie(a, b, c) {
      var d = !1,
          f = Fa,
          l = b.contextType;
      "object" === typeof l && null !== l ? l = U(l) : (f = I(b) ? Oa : N.current, d = b.contextTypes, l = (d = null !== d && void 0 !== d) ? Z(a, f) : Fa);
      b = new b(c, l);
      a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
      b.updater = Wb;
      a.stateNode = b;
      b._reactInternalFiber = a;
      d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = f, a.__reactInternalMemoizedMaskedChildContext = l);
      return b;
    }

    function je(a, b, c, d) {
      a = b.state;
      "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
      "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
      b.state !== a && Wb.enqueueReplaceState(b, b.state, null);
    }

    function Pc(a, b, c, d) {
      var f = a.stateNode;
      f.props = c;
      f.state = a.memoizedState;
      f.refs = ke;
      p(a);
      var l = b.contextType;
      "object" === typeof l && null !== l ? f.context = U(l) : (l = I(b) ? Oa : N.current, f.context = Z(a, l));
      wb(a, c, f, d);
      f.state = a.memoizedState;
      l = b.getDerivedStateFromProps;
      "function" === typeof l && (Vb(a, b, l, c), f.state = a.memoizedState);
      "function" === typeof b.getDerivedStateFromProps || "function" === typeof f.getSnapshotBeforeUpdate || "function" !== typeof f.UNSAFE_componentWillMount && "function" !== typeof f.componentWillMount || (b = f.state, "function" === typeof f.componentWillMount && f.componentWillMount(), "function" === typeof f.UNSAFE_componentWillMount && f.UNSAFE_componentWillMount(), b !== f.state && Wb.enqueueReplaceState(f, f.state, null), wb(a, c, f, d), f.state = a.memoizedState);
      "function" === typeof f.componentDidMount && (a.effectTag |= 4);
    }

    function xb(a, b, c) {
      a = c.ref;

      if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
          if (c = c._owner) {
            if (1 !== c.tag) throw Error(m(309));
            var d = c.stateNode;
          }

          if (!d) throw Error(m(147, a));
          var f = "" + a;
          if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;

          b = function b(_b) {
            var a = d.refs;
            a === ke && (a = d.refs = {});
            null === _b ? delete a[f] : a[f] = _b;
          };

          b._stringRef = f;
          return b;
        }

        if ("string" !== typeof a) throw Error(m(284));
        if (!c._owner) throw Error(m(290, a));
      }

      return a;
    }

    function Xb(a, b) {
      if ("textarea" !== a.type) throw Error(m(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
    }

    function le(a) {
      function b(b, c) {
        if (a) {
          var d = b.lastEffect;
          null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
          c.nextEffect = null;
          c.effectTag = 8;
        }
      }

      function c(c, d) {
        if (!a) return null;

        for (; null !== d;) {
          b(c, d), d = d.sibling;
        }

        return null;
      }

      function d(b, a) {
        for (b = new Map(); null !== a;) {
          null !== a.key ? b.set(a.key, a) : b.set(a.index, a), a = a.sibling;
        }

        return b;
      }

      function f(b, a) {
        b = Qa(b, a);
        b.index = 0;
        b.sibling = null;
        return b;
      }

      function l(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
      }

      function e(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
      }

      function g(b, a, c, d) {
        if (null === a || 6 !== a.tag) return a = Qc(c, b.mode, d), a.return = b, a;
        a = f(a, c);
        a.return = b;
        return a;
      }

      function p(b, a, c, d) {
        if (null !== a && a.elementType === c.type) return d = f(a, c.props), d.ref = xb(b, a, c), d.return = b, d;
        d = Yb(c.type, c.key, c.props, null, b.mode, d);
        d.ref = xb(b, a, c);
        d.return = b;
        return d;
      }

      function t(b, a, c, d) {
        if (null === a || 4 !== a.tag || a.stateNode.containerInfo !== c.containerInfo || a.stateNode.implementation !== c.implementation) return a = Rc(c, b.mode, d), a.return = b, a;
        a = f(a, c.children || []);
        a.return = b;
        return a;
      }

      function h(b, a, c, d, l) {
        if (null === a || 7 !== a.tag) return a = Ja(c, b.mode, d, l), a.return = b, a;
        a = f(a, c);
        a.return = b;
        return a;
      }

      function n(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Qc("" + b, a.mode, c), b.return = a, b;

        if ("object" === typeof b && null !== b) {
          switch (b.$$typeof) {
            case Zb:
              return c = Yb(b.type, b.key, b.props, null, a.mode, c), c.ref = xb(a, null, b), c.return = a, c;

            case pb:
              return b = Rc(b, a.mode, c), b.return = a, b;
          }

          if ($b(b) || v(b)) return b = Ja(b, a.mode, c, null), b.return = a, b;
          Xb(a, b);
        }

        return null;
      }

      function q(b, a, c, d) {
        var f = null !== a ? a.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== f ? null : g(b, a, "" + c, d);

        if ("object" === typeof c && null !== c) {
          switch (c.$$typeof) {
            case Zb:
              return c.key === f ? c.type === Na ? h(b, a, c.props.children, d, f) : p(b, a, c, d) : null;

            case pb:
              return c.key === f ? t(b, a, c, d) : null;
          }

          if ($b(c) || v(c)) return null !== f ? null : h(b, a, c, d, null);
          Xb(b, c);
        }

        return null;
      }

      function r(b, a, c, d, f) {
        if ("string" === typeof d || "number" === typeof d) return b = b.get(c) || null, g(a, b, "" + d, f);

        if ("object" === typeof d && null !== d) {
          switch (d.$$typeof) {
            case Zb:
              return b = b.get(null === d.key ? c : d.key) || null, d.type === Na ? h(a, b, d.props.children, f, d.key) : p(a, b, d, f);

            case pb:
              return b = b.get(null === d.key ? c : d.key) || null, t(a, b, d, f);
          }

          if ($b(d) || v(d)) return b = b.get(c) || null, h(a, b, d, f, null);
          Xb(a, d);
        }

        return null;
      }

      function F(f, e, u, g) {
        for (var m = null, C = null, p = e, h = e = 0, t = null; null !== p && h < u.length; h++) {
          p.index > h ? (t = p, p = null) : t = p.sibling;
          var fa = q(f, p, u[h], g);

          if (null === fa) {
            null === p && (p = t);
            break;
          }

          a && p && null === fa.alternate && b(f, p);
          e = l(fa, e, h);
          null === C ? m = fa : C.sibling = fa;
          C = fa;
          p = t;
        }

        if (h === u.length) return c(f, p), m;

        if (null === p) {
          for (; h < u.length; h++) {
            p = n(f, u[h], g), null !== p && (e = l(p, e, h), null === C ? m = p : C.sibling = p, C = p);
          }

          return m;
        }

        for (p = d(f, p); h < u.length; h++) {
          t = r(p, f, h, u[h], g), null !== t && (a && null !== t.alternate && p.delete(null === t.key ? h : t.key), e = l(t, e, h), null === C ? m = t : C.sibling = t, C = t);
        }

        a && p.forEach(function (a) {
          return b(f, a);
        });
        return m;
      }

      function x(f, e, u, g) {
        var C = v(u);
        if ("function" !== typeof C) throw Error(m(150));
        u = C.call(u);
        if (null == u) throw Error(m(151));

        for (var p = C = null, h = e, t = e = 0, fa = null, D = u.next(); null !== h && !D.done; t++, D = u.next()) {
          h.index > t ? (fa = h, h = null) : fa = h.sibling;
          var F = q(f, h, D.value, g);

          if (null === F) {
            null === h && (h = fa);
            break;
          }

          a && h && null === F.alternate && b(f, h);
          e = l(F, e, t);
          null === p ? C = F : p.sibling = F;
          p = F;
          h = fa;
        }

        if (D.done) return c(f, h), C;

        if (null === h) {
          for (; !D.done; t++, D = u.next()) {
            D = n(f, D.value, g), null !== D && (e = l(D, e, t), null === p ? C = D : p.sibling = D, p = D);
          }

          return C;
        }

        for (h = d(f, h); !D.done; t++, D = u.next()) {
          D = r(h, f, t, D.value, g), null !== D && (a && null !== D.alternate && h.delete(null === D.key ? t : D.key), e = l(D, e, t), null === p ? C = D : p.sibling = D, p = D);
        }

        a && h.forEach(function (a) {
          return b(f, a);
        });
        return C;
      }

      return function (a, d, l, u) {
        var g = "object" === typeof l && null !== l && l.type === Na && null === l.key;
        g && (l = l.props.children);
        var C = "object" === typeof l && null !== l;
        if (C) switch (l.$$typeof) {
          case Zb:
            a: {
              C = l.key;

              for (g = d; null !== g;) {
                if (g.key === C) {
                  switch (g.tag) {
                    case 7:
                      if (l.type === Na) {
                        c(a, g.sibling);
                        d = f(g, l.props.children);
                        d.return = a;
                        a = d;
                        break a;
                      }

                      break;

                    default:
                      if (g.elementType === l.type) {
                        c(a, g.sibling);
                        d = f(g, l.props);
                        d.ref = xb(a, g, l);
                        d.return = a;
                        a = d;
                        break a;
                      }

                  }

                  c(a, g);
                  break;
                } else b(a, g);

                g = g.sibling;
              }

              l.type === Na ? (d = Ja(l.props.children, a.mode, u, l.key), d.return = a, a = d) : (u = Yb(l.type, l.key, l.props, null, a.mode, u), u.ref = xb(a, d, l), u.return = a, a = u);
            }

            return e(a);

          case pb:
            a: {
              for (g = l.key; null !== d;) {
                if (d.key === g) {
                  if (4 === d.tag && d.stateNode.containerInfo === l.containerInfo && d.stateNode.implementation === l.implementation) {
                    c(a, d.sibling);
                    d = f(d, l.children || []);
                    d.return = a;
                    a = d;
                    break a;
                  } else {
                    c(a, d);
                    break;
                  }
                } else b(a, d);
                d = d.sibling;
              }

              d = Rc(l, a.mode, u);
              d.return = a;
              a = d;
            }

            return e(a);
        }
        if ("string" === typeof l || "number" === typeof l) return l = "" + l, null !== d && 6 === d.tag ? (c(a, d.sibling), d = f(d, l), d.return = a, a = d) : (c(a, d), d = Qc(l, a.mode, u), d.return = a, a = d), e(a);
        if ($b(l)) return F(a, d, l, u);
        if (v(l)) return x(a, d, l, u);
        C && Xb(a, l);
        if ("undefined" === typeof l && !g) switch (a.tag) {
          case 1:
          case 0:
            throw a = a.type, Error(m(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
      };
    }

    function sa(a) {
      if (a === zb) throw Error(m(174));
      return a;
    }

    function Sc(a, b) {
      B(ib, b);
      B(Ab, a);
      B(ha, zb);
      a = Rf(b);
      A(ha);
      B(ha, a);
    }

    function jb() {
      A(ha);
      A(Ab);
      A(ib);
    }

    function me(a) {
      var b = sa(ib.current),
          c = sa(ha.current);
      b = Sf(c, a.type, b);
      c !== b && (B(Ab, a), B(ha, b));
    }

    function Tc(a) {
      Ab.current === a && (A(ha), A(Ab));
    }

    function ac(a) {
      for (var b = a; null !== b;) {
        if (13 === b.tag) {
          var c = b.memoizedState;
          if (null !== c && (c = c.dehydrated, null === c || Tf(c) || Uf(c))) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
          if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
          b.child.return = b;
          b = b.child;
          continue;
        }

        if (b === a) break;

        for (; null === b.sibling;) {
          if (null === b.return || b.return === a) return null;
          b = b.return;
        }

        b.sibling.return = b.return;
        b = b.sibling;
      }

      return null;
    }

    function Uc(a, b) {
      return {
        responder: a,
        props: b
      };
    }

    function aa() {
      throw Error(m(321));
    }

    function Vc(a, b) {
      if (null === b) return !1;

      for (var c = 0; c < b.length && c < a.length; c++) {
        if (!Pa(a[c], b[c])) return !1;
      }

      return !0;
    }

    function Wc(a, b, c, d, f, l) {
      Ka = l;
      G = b;
      b.memoizedState = null;
      b.updateQueue = null;
      b.expirationTime = 0;
      bc.current = null === a || null === a.memoizedState ? Vf : Wf;
      a = c(d, f);

      if (b.expirationTime === Ka) {
        l = 0;

        do {
          b.expirationTime = 0;
          if (!(25 > l)) throw Error(m(301));
          l += 1;
          O = P = null;
          b.updateQueue = null;
          bc.current = Xf;
          a = c(d, f);
        } while (b.expirationTime === Ka);
      }

      bc.current = cc;
      b = null !== P && null !== P.next;
      Ka = 0;
      O = P = G = null;
      dc = !1;
      if (b) throw Error(m(300));
      return a;
    }

    function kb() {
      var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      null === O ? G.memoizedState = O = a : O = O.next = a;
      return O;
    }

    function lb() {
      if (null === P) {
        var a = G.alternate;
        a = null !== a ? a.memoizedState : null;
      } else a = P.next;

      var b = null === O ? G.memoizedState : O.next;
      if (null !== b) O = b, P = a;else {
        if (null === a) throw Error(m(310));
        P = a;
        a = {
          memoizedState: P.memoizedState,
          baseState: P.baseState,
          baseQueue: P.baseQueue,
          queue: P.queue,
          next: null
        };
        null === O ? G.memoizedState = O = a : O = O.next = a;
      }
      return O;
    }

    function Ra(a, b) {
      return "function" === typeof b ? b(a) : b;
    }

    function ec(a) {
      var b = lb(),
          c = b.queue;
      if (null === c) throw Error(m(311));
      c.lastRenderedReducer = a;
      var d = P,
          f = d.baseQueue,
          l = c.pending;

      if (null !== l) {
        if (null !== f) {
          var e = f.next;
          f.next = l.next;
          l.next = e;
        }

        d.baseQueue = f = l;
        c.pending = null;
      }

      if (null !== f) {
        f = f.next;
        d = d.baseState;
        var g = e = l = null,
            p = f;

        do {
          var h = p.expirationTime;

          if (h < Ka) {
            var t = {
              expirationTime: p.expirationTime,
              suspenseConfig: p.suspenseConfig,
              action: p.action,
              eagerReducer: p.eagerReducer,
              eagerState: p.eagerState,
              next: null
            };
            null === g ? (e = g = t, l = d) : g = g.next = t;
            h > G.expirationTime && (G.expirationTime = h, Ub(h));
          } else null !== g && (g = g.next = {
            expirationTime: 1073741823,
            suspenseConfig: p.suspenseConfig,
            action: p.action,
            eagerReducer: p.eagerReducer,
            eagerState: p.eagerState,
            next: null
          }), fe(h, p.suspenseConfig), d = p.eagerReducer === a ? p.eagerState : a(d, p.action);

          p = p.next;
        } while (null !== p && p !== f);

        null === g ? l = d : g.next = e;
        Pa(d, b.memoizedState) || (ra = !0);
        b.memoizedState = d;
        b.baseState = l;
        b.baseQueue = g;
        c.lastRenderedState = d;
      }

      return [b.memoizedState, c.dispatch];
    }

    function fc(a) {
      var b = lb(),
          c = b.queue;
      if (null === c) throw Error(m(311));
      c.lastRenderedReducer = a;
      var d = c.dispatch,
          f = c.pending,
          l = b.memoizedState;

      if (null !== f) {
        c.pending = null;
        var e = f = f.next;

        do {
          l = a(l, e.action), e = e.next;
        } while (e !== f);

        Pa(l, b.memoizedState) || (ra = !0);
        b.memoizedState = l;
        null === b.baseQueue && (b.baseState = l);
        c.lastRenderedState = l;
      }

      return [l, d];
    }

    function Xc(a) {
      var b = kb();
      "function" === typeof a && (a = a());
      b.memoizedState = b.baseState = a;
      a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Ra,
        lastRenderedState: a
      };
      a = a.dispatch = ne.bind(null, G, a);
      return [b.memoizedState, a];
    }

    function Yc(a, b, c, d) {
      a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
      };
      b = G.updateQueue;
      null === b ? (b = {
        lastEffect: null
      }, G.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
      return a;
    }

    function oe() {
      return lb().memoizedState;
    }

    function Zc(a, b, c, d) {
      var f = kb();
      G.effectTag |= a;
      f.memoizedState = Yc(1 | b, c, void 0, void 0 === d ? null : d);
    }

    function $c(a, b, c, d) {
      var f = lb();
      d = void 0 === d ? null : d;
      var l = void 0;

      if (null !== P) {
        var e = P.memoizedState;
        l = e.destroy;

        if (null !== d && Vc(d, e.deps)) {
          Yc(b, c, l, d);
          return;
        }
      }

      G.effectTag |= a;
      f.memoizedState = Yc(1 | b, c, l, d);
    }

    function pe(a, b) {
      return Zc(516, 4, a, b);
    }

    function gc(a, b) {
      return $c(516, 4, a, b);
    }

    function qe(a, b) {
      return $c(4, 2, a, b);
    }

    function re(a, b) {
      if ("function" === typeof b) return a = a(), b(a), function () {
        b(null);
      };
      if (null !== b && void 0 !== b) return a = a(), b.current = a, function () {
        b.current = null;
      };
    }

    function se(a, b, c) {
      c = null !== c && void 0 !== c ? c.concat([a]) : null;
      return $c(4, 2, re.bind(null, b, a), c);
    }

    function ad() {}

    function te(a, b) {
      kb().memoizedState = [a, void 0 === b ? null : b];
      return a;
    }

    function hc(a, b) {
      var c = lb();
      b = void 0 === b ? null : b;
      var d = c.memoizedState;
      if (null !== d && null !== b && Vc(b, d[1])) return d[0];
      c.memoizedState = [a, b];
      return a;
    }

    function ue(a, b) {
      var c = lb();
      b = void 0 === b ? null : b;
      var d = c.memoizedState;
      if (null !== d && null !== b && Vc(b, d[1])) return d[0];
      a = a();
      c.memoizedState = [a, b];
      return a;
    }

    function bd(a, b, c) {
      var d = J();
      n(98 > d ? 98 : d, function () {
        a(!0);
      });
      n(97 < d ? 97 : d, function () {
        var d = ia.suspense;
        ia.suspense = void 0 === b ? null : b;

        try {
          a(!1), c();
        } finally {
          ia.suspense = d;
        }
      });
    }

    function ne(a, b, c) {
      var d = pa(),
          f = Bb.suspense;
      d = Sa(d, a, f);
      f = {
        expirationTime: d,
        suspenseConfig: f,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
      };
      var l = b.pending;
      null === l ? f.next = f : (f.next = l.next, l.next = f);
      b.pending = f;
      l = a.alternate;
      if (a === G || null !== l && l === G) dc = !0, f.expirationTime = Ka, G.expirationTime = Ka;else {
        if (0 === a.expirationTime && (null === l || 0 === l.expirationTime) && (l = b.lastRenderedReducer, null !== l)) try {
          var e = b.lastRenderedState,
              g = l(e, c);
          f.eagerReducer = l;
          f.eagerState = g;
          if (Pa(g, e)) return;
        } catch (fa) {} finally {}
        ya(a, d);
      }
    }

    function ve(a, b) {
      var c = ta(5, null, null, 0);
      c.elementType = "DELETED";
      c.type = "DELETED";
      c.stateNode = b;
      c.return = a;
      c.effectTag = 8;
      null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
    }

    function we(a, b) {
      switch (a.tag) {
        case 5:
          return b = Yf(b, a.type, a.pendingProps), null !== b ? (a.stateNode = b, !0) : !1;

        case 6:
          return b = Zf(b, a.pendingProps), null !== b ? (a.stateNode = b, !0) : !1;

        case 13:
          return !1;

        default:
          return !1;
      }
    }

    function cd(a) {
      if (Ta) {
        var b = Ua;

        if (b) {
          var c = b;

          if (!we(a, b)) {
            b = dd(c);

            if (!b || !we(a, b)) {
              a.effectTag = a.effectTag & -1025 | 2;
              Ta = !1;
              za = a;
              return;
            }

            ve(za, c);
          }

          za = a;
          Ua = xe(b);
        } else a.effectTag = a.effectTag & -1025 | 2, Ta = !1, za = a;
      }
    }

    function ye(a) {
      for (a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;) {
        a = a.return;
      }

      za = a;
    }

    function ic(a) {
      if (!Aa || a !== za) return !1;
      if (!Ta) return ye(a), Ta = !0, !1;
      var b = a.type;
      if (5 !== a.tag || "head" !== b && "body" !== b && !ed(b, a.memoizedProps)) for (b = Ua; b;) {
        ve(a, b), b = dd(b);
      }
      ye(a);

      if (13 === a.tag) {
        if (!Aa) throw Error(m(316));
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(m(317));
        Ua = $f(a);
      } else Ua = za ? dd(a.stateNode) : null;

      return !0;
    }

    function fd() {
      Aa && (Ua = za = null, Ta = !1);
    }

    function ba(a, b, c, d) {
      b.child = null === a ? gd(b, null, c, d) : mb(b, a.child, c, d);
    }

    function ze(a, b, c, d, f) {
      c = c.render;
      var l = b.ref;
      ea(b, f);
      d = Wc(a, b, c, d, l, f);
      if (null !== a && !ra) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= f && (a.expirationTime = 0), Ba(a, b, f);
      b.effectTag |= 1;
      ba(a, b, d, f);
      return b.child;
    }

    function Ae(a, b, c, d, f, l) {
      if (null === a) {
        var e = c.type;
        if ("function" === typeof e && !hd(e) && void 0 === e.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = e, Be(a, b, e, d, f, l);
        a = Yb(c.type, null, d, null, b.mode, l);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
      }

      e = a.child;
      if (f < l && (f = e.memoizedProps, c = c.compare, c = null !== c ? c : eb, c(f, d) && a.ref === b.ref)) return Ba(a, b, l);
      b.effectTag |= 1;
      a = Qa(e, d);
      a.ref = b.ref;
      a.return = b;
      return b.child = a;
    }

    function Be(a, b, c, d, f, l) {
      return null !== a && eb(a.memoizedProps, d) && a.ref === b.ref && (ra = !1, f < l) ? (b.expirationTime = a.expirationTime, Ba(a, b, l)) : id(a, b, c, d, l);
    }

    function Ce(a, b) {
      var c = b.ref;
      if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
    }

    function id(a, b, c, d, f) {
      var l = I(c) ? Oa : N.current;
      l = Z(b, l);
      ea(b, f);
      c = Wc(a, b, c, d, l, f);
      if (null !== a && !ra) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= f && (a.expirationTime = 0), Ba(a, b, f);
      b.effectTag |= 1;
      ba(a, b, c, f);
      return b.child;
    }

    function De(a, b, c, d, f) {
      if (I(c)) {
        var l = !0;
        va(b);
      } else l = !1;

      ea(b, f);
      if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), ie(b, c, d), Pc(b, c, d, f), d = !0;else if (null === a) {
        var e = b.stateNode,
            g = b.memoizedProps;
        e.props = g;
        var p = e.context,
            h = c.contextType;
        "object" === typeof h && null !== h ? h = U(h) : (h = I(c) ? Oa : N.current, h = Z(b, h));
        var m = c.getDerivedStateFromProps,
            n = "function" === typeof m || "function" === typeof e.getSnapshotBeforeUpdate;
        n || "function" !== typeof e.UNSAFE_componentWillReceiveProps && "function" !== typeof e.componentWillReceiveProps || (g !== d || p !== h) && je(b, e, d, h);
        Ia = !1;
        var q = b.memoizedState;
        e.state = q;
        wb(b, d, e, f);
        p = b.memoizedState;
        g !== d || q !== p || S.current || Ia ? ("function" === typeof m && (Vb(b, c, m, d), p = b.memoizedState), (g = Ia || he(b, c, g, d, q, p, h)) ? (n || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || ("function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount()), "function" === typeof e.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof e.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = p), e.props = d, e.state = p, e.context = h, d = g) : ("function" === typeof e.componentDidMount && (b.effectTag |= 4), d = !1);
      } else e = b.stateNode, t(a, b), g = b.memoizedProps, e.props = b.type === b.elementType ? g : T(b.type, g), p = e.context, h = c.contextType, "object" === typeof h && null !== h ? h = U(h) : (h = I(c) ? Oa : N.current, h = Z(b, h)), m = c.getDerivedStateFromProps, (n = "function" === typeof m || "function" === typeof e.getSnapshotBeforeUpdate) || "function" !== typeof e.UNSAFE_componentWillReceiveProps && "function" !== typeof e.componentWillReceiveProps || (g !== d || p !== h) && je(b, e, d, h), Ia = !1, p = b.memoizedState, e.state = p, wb(b, d, e, f), q = b.memoizedState, g !== d || p !== q || S.current || Ia ? ("function" === typeof m && (Vb(b, c, m, d), q = b.memoizedState), (m = Ia || he(b, c, g, d, p, q, h)) ? (n || "function" !== typeof e.UNSAFE_componentWillUpdate && "function" !== typeof e.componentWillUpdate || ("function" === typeof e.componentWillUpdate && e.componentWillUpdate(d, q, h), "function" === typeof e.UNSAFE_componentWillUpdate && e.UNSAFE_componentWillUpdate(d, q, h)), "function" === typeof e.componentDidUpdate && (b.effectTag |= 4), "function" === typeof e.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof e.componentDidUpdate || g === a.memoizedProps && p === a.memoizedState || (b.effectTag |= 4), "function" !== typeof e.getSnapshotBeforeUpdate || g === a.memoizedProps && p === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = q), e.props = d, e.state = q, e.context = h, d = m) : ("function" !== typeof e.componentDidUpdate || g === a.memoizedProps && p === a.memoizedState || (b.effectTag |= 4), "function" !== typeof e.getSnapshotBeforeUpdate || g === a.memoizedProps && p === a.memoizedState || (b.effectTag |= 256), d = !1);
      return jd(a, b, c, d, l, f);
    }

    function jd(a, b, c, d, f, e) {
      Ce(a, b);
      var l = 0 !== (b.effectTag & 64);
      if (!d && !l) return f && sb(b, c, !1), Ba(a, b, e);
      d = b.stateNode;
      ag.current = b;
      var g = l && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
      b.effectTag |= 1;
      null !== a && l ? (b.child = mb(b, a.child, null, e), b.child = mb(b, null, g, e)) : ba(a, b, g, e);
      b.memoizedState = d.state;
      f && sb(b, c, !0);
      return b.child;
    }

    function Ee(a) {
      var b = a.stateNode;
      b.pendingContext ? qb(a, b.pendingContext, b.pendingContext !== b.context) : b.context && qb(a, b.context, !1);
      Sc(a, b.containerInfo);
    }

    function Fe(a, b, c) {
      var d = b.mode,
          f = b.pendingProps,
          e = E.current,
          g = !1,
          p;
      (p = 0 !== (b.effectTag & 64)) || (p = 0 !== (e & 2) && (null === a || null !== a.memoizedState));
      p ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === f.fallback || !0 === f.unstable_avoidThisFallback || (e |= 1);
      B(E, e & 1);

      if (null === a) {
        void 0 !== f.fallback && cd(b);

        if (g) {
          g = f.fallback;
          f = Ja(null, d, 0, null);
          f.return = b;
          if (0 === (b.mode & 2)) for (a = null !== b.memoizedState ? b.child.child : b.child, f.child = a; null !== a;) {
            a.return = f, a = a.sibling;
          }
          c = Ja(g, d, c, null);
          c.return = b;
          f.sibling = c;
          b.memoizedState = kd;
          b.child = f;
          return c;
        }

        d = f.children;
        b.memoizedState = null;
        return b.child = gd(b, null, d, c);
      }

      if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;

        if (g) {
          f = f.fallback;
          c = Qa(a, a.pendingProps);
          c.return = b;
          if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for (c.child = g; null !== g;) {
            g.return = c, g = g.sibling;
          }
          d = Qa(d, f);
          d.return = b;
          c.sibling = d;
          c.childExpirationTime = 0;
          b.memoizedState = kd;
          b.child = c;
          return d;
        }

        c = mb(b, a.child, f.children, c);
        b.memoizedState = null;
        return b.child = c;
      }

      a = a.child;

      if (g) {
        g = f.fallback;
        f = Ja(null, d, 0, null);
        f.return = b;
        f.child = a;
        null !== a && (a.return = f);
        if (0 === (b.mode & 2)) for (a = null !== b.memoizedState ? b.child.child : b.child, f.child = a; null !== a;) {
          a.return = f, a = a.sibling;
        }
        c = Ja(g, d, c, null);
        c.return = b;
        f.sibling = c;
        c.effectTag |= 2;
        f.childExpirationTime = 0;
        b.memoizedState = kd;
        b.child = f;
        return c;
      }

      b.memoizedState = null;
      return b.child = mb(b, a, f.children, c);
    }

    function Ge(a, b) {
      a.expirationTime < b && (a.expirationTime = b);
      var c = a.alternate;
      null !== c && c.expirationTime < b && (c.expirationTime = b);
      xa(a.return, b);
    }

    function ld(a, b, c, d, f, e) {
      var l = a.memoizedState;
      null === l ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: f,
        lastEffect: e
      } : (l.isBackwards = b, l.rendering = null, l.renderingStartTime = 0, l.last = d, l.tail = c, l.tailExpiration = 0, l.tailMode = f, l.lastEffect = e);
    }

    function He(a, b, c) {
      var d = b.pendingProps,
          f = d.revealOrder,
          e = d.tail;
      ba(a, b, d.children, c);
      d = E.current;
      if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for (a = b.child; null !== a;) {
          if (13 === a.tag) null !== a.memoizedState && Ge(a, c);else if (19 === a.tag) Ge(a, c);else if (null !== a.child) {
            a.child.return = a;
            a = a.child;
            continue;
          }
          if (a === b) break a;

          for (; null === a.sibling;) {
            if (null === a.return || a.return === b) break a;
            a = a.return;
          }

          a.sibling.return = a.return;
          a = a.sibling;
        }
        d &= 1;
      }
      B(E, d);
      if (0 === (b.mode & 2)) b.memoizedState = null;else switch (f) {
        case "forwards":
          c = b.child;

          for (f = null; null !== c;) {
            a = c.alternate, null !== a && null === ac(a) && (f = c), c = c.sibling;
          }

          c = f;
          null === c ? (f = b.child, b.child = null) : (f = c.sibling, c.sibling = null);
          ld(b, !1, f, c, e, b.lastEffect);
          break;

        case "backwards":
          c = null;
          f = b.child;

          for (b.child = null; null !== f;) {
            a = f.alternate;

            if (null !== a && null === ac(a)) {
              b.child = f;
              break;
            }

            a = f.sibling;
            f.sibling = c;
            c = f;
            f = a;
          }

          ld(b, !0, c, null, e, b.lastEffect);
          break;

        case "together":
          ld(b, !1, null, null, void 0, b.lastEffect);
          break;

        default:
          b.memoizedState = null;
      }
      return b.child;
    }

    function Ba(a, b, c) {
      null !== a && (b.dependencies = a.dependencies);
      var d = b.expirationTime;
      0 !== d && Ub(d);
      if (b.childExpirationTime < c) return null;
      if (null !== a && b.child !== a.child) throw Error(m(153));

      if (null !== b.child) {
        a = b.child;
        c = Qa(a, a.pendingProps);
        b.child = c;

        for (c.return = b; null !== a.sibling;) {
          a = a.sibling, c = c.sibling = Qa(a, a.pendingProps), c.return = b;
        }

        c.sibling = null;
      }

      return b.child;
    }

    function jc(a, b) {
      switch (a.tailMode) {
        case "hidden":
          b = a.tail;

          for (var c = null; null !== b;) {
            null !== b.alternate && (c = b), b = b.sibling;
          }

          null === c ? a.tail = null : c.sibling = null;
          break;

        case "collapsed":
          c = a.tail;

          for (var d = null; null !== c;) {
            null !== c.alternate && (d = c), c = c.sibling;
          }

          null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
      }
    }

    function bg(a, b, c) {
      var d = b.pendingProps;

      switch (b.tag) {
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return null;

        case 1:
          return I(b.type) && na(), null;

        case 3:
          return jb(), A(S), A(N), d = b.stateNode, d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null), null !== a && null !== a.child || !ic(b) || (b.effectTag |= 4), kc(b), null;

        case 5:
          Tc(b);
          var f = sa(ib.current);
          c = b.type;
          if (null !== a && null != b.stateNode) md(a, b, c, d, f), a.ref !== b.ref && (b.effectTag |= 128);else {
            if (!d) {
              if (null === b.stateNode) throw Error(m(166));
              return null;
            }

            a = sa(ha.current);

            if (ic(b)) {
              if (!Aa) throw Error(m(175));
              a = cg(b.stateNode, b.type, b.memoizedProps, f, a, b);
              b.updateQueue = a;
              null !== a && (b.effectTag |= 4);
            } else {
              var e = dg(c, d, f, a, b);

              _lc(e, b, !1, !1);

              b.stateNode = e;
              Ie(e, c, d, f, a) && (b.effectTag |= 4);
            }

            null !== b.ref && (b.effectTag |= 128);
          }
          return null;

        case 6:
          if (a && null != b.stateNode) nd(a, b, a.memoizedProps, d);else {
            if ("string" !== typeof d && null === b.stateNode) throw Error(m(166));
            a = sa(ib.current);
            f = sa(ha.current);

            if (ic(b)) {
              if (!Aa) throw Error(m(176));
              eg(b.stateNode, b.memoizedProps, b) && (b.effectTag |= 4);
            } else b.stateNode = Je(d, a, f, b);
          }
          return null;

        case 13:
          A(E);
          d = b.memoizedState;
          if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
          d = null !== d;
          f = !1;
          null === a ? void 0 !== b.memoizedProps.fallback && ic(b) : (c = a.memoizedState, f = null !== c, d || null === c || (c = a.child.sibling, null !== c && (e = b.firstEffect, null !== e ? (b.firstEffect = c, c.nextEffect = e) : (b.firstEffect = b.lastEffect = c, c.nextEffect = null), c.effectTag = 8)));
          if (d && !f && 0 !== (b.mode & 2)) if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (E.current & 1)) K === Va && (K = mc);else {
            if (K === Va || K === mc) K = nc;
            0 !== Cb && null !== ca && (Wa(ca, V), Ke(ca, Cb));
          }
          Db && d && (b.effectTag |= 4);
          ua && (d || f) && (b.effectTag |= 4);
          return null;

        case 4:
          return jb(), kc(b), null;

        case 10:
          return fb(b), null;

        case 17:
          return I(b.type) && na(), null;

        case 19:
          A(E);
          d = b.memoizedState;
          if (null === d) return null;
          f = 0 !== (b.effectTag & 64);
          e = d.rendering;
          if (null === e) {
            if (f) jc(d, !1);else {
              if (K !== Va || null !== a && 0 !== (a.effectTag & 64)) for (a = b.child; null !== a;) {
                e = ac(a);

                if (null !== e) {
                  b.effectTag |= 64;
                  jc(d, !1);
                  a = e.updateQueue;
                  null !== a && (b.updateQueue = a, b.effectTag |= 4);
                  null === d.lastEffect && (b.firstEffect = null);
                  b.lastEffect = d.lastEffect;
                  a = c;

                  for (d = b.child; null !== d;) {
                    f = d, c = a, f.effectTag &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, e = f.alternate, null === e ? (f.childExpirationTime = 0, f.expirationTime = c, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null) : (f.childExpirationTime = e.childExpirationTime, f.expirationTime = e.expirationTime, f.child = e.child, f.memoizedProps = e.memoizedProps, f.memoizedState = e.memoizedState, f.updateQueue = e.updateQueue, c = e.dependencies, f.dependencies = null === c ? null : {
                      expirationTime: c.expirationTime,
                      firstContext: c.firstContext,
                      responders: c.responders
                    }), d = d.sibling;
                  }

                  B(E, E.current & 1 | 2);
                  return b.child;
                }

                a = a.sibling;
              }
            }
          } else {
            if (!f) if (a = ac(e), null !== a) {
              if (b.effectTag |= 64, f = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.effectTag |= 4), jc(d, !0), null === d.tail && "hidden" === d.tailMode && !e.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
            } else 2 * ja() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, f = !0, jc(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
            d.isBackwards ? (e.sibling = b.child, b.child = e) : (a = d.last, null !== a ? a.sibling = e : b.child = e, d.last = e);
          }
          return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = ja() + 500), a = d.tail, d.rendering = a, d.tail = a.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = ja(), a.sibling = null, b = E.current, B(E, f ? b & 1 | 2 : b & 1), a) : null;
      }

      throw Error(m(156, b.tag));
    }

    function fg(a) {
      switch (a.tag) {
        case 1:
          I(a.type) && na();
          var b = a.effectTag;
          return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;

        case 3:
          jb();
          A(S);
          A(N);
          b = a.effectTag;
          if (0 !== (b & 64)) throw Error(m(285));
          a.effectTag = b & -4097 | 64;
          return a;

        case 5:
          return Tc(a), null;

        case 13:
          return A(E), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;

        case 19:
          return A(E), null;

        case 4:
          return jb(), null;

        case 10:
          return fb(a), null;

        default:
          return null;
      }
    }

    function od(a, b) {
      return {
        value: a,
        source: b,
        stack: Ea(b)
      };
    }

    function pd(a, b) {
      var c = b.source,
          d = b.stack;
      null === d && null !== c && (d = Ea(c));
      null !== c && r(c.type);
      b = b.value;
      null !== a && 1 === a.tag && r(a.type);

      try {
        console.error(b);
      } catch (f) {
        setTimeout(function () {
          throw f;
        });
      }
    }

    function gg(a, b) {
      try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
      } catch (c) {
        Xa(a, c);
      }
    }

    function Le(a) {
      var b = a.ref;
      if (null !== b) if ("function" === typeof b) try {
        b(null);
      } catch (c) {
        Xa(a, c);
      } else b.current = null;
    }

    function hg(a, b) {
      switch (b.tag) {
        case 0:
        case 11:
        case 15:
        case 22:
          return;

        case 1:
          if (b.effectTag & 256 && null !== a) {
            var c = a.memoizedProps,
                d = a.memoizedState;
            a = b.stateNode;
            b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : T(b.type, c), d);
            a.__reactInternalSnapshotBeforeUpdate = b;
          }

          return;

        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
          return;
      }

      throw Error(m(163));
    }

    function qd(a, b) {
      b = b.updateQueue;
      b = null !== b ? b.lastEffect : null;

      if (null !== b) {
        var c = b = b.next;

        do {
          if ((c.tag & a) === a) {
            var d = c.destroy;
            c.destroy = void 0;
            void 0 !== d && d();
          }

          c = c.next;
        } while (c !== b);
      }
    }

    function Me(a, b) {
      b = b.updateQueue;
      b = null !== b ? b.lastEffect : null;

      if (null !== b) {
        var c = b = b.next;

        do {
          if ((c.tag & a) === a) {
            var d = c.create;
            c.destroy = d();
          }

          c = c.next;
        } while (c !== b);
      }
    }

    function ig(a, b, c) {
      switch (c.tag) {
        case 0:
        case 11:
        case 15:
        case 22:
          Me(3, c);
          return;

        case 1:
          a = c.stateNode;
          if (c.effectTag & 4) if (null === b) a.componentDidMount();else {
            var d = c.elementType === c.type ? b.memoizedProps : T(c.type, b.memoizedProps);
            a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
          }
          b = c.updateQueue;
          null !== b && ge(c, b, a);
          return;

        case 3:
          b = c.updateQueue;

          if (null !== b) {
            a = null;
            if (null !== c.child) switch (c.child.tag) {
              case 5:
                a = rd(c.child.stateNode);
                break;

              case 1:
                a = c.child.stateNode;
            }
            ge(c, b, a);
          }

          return;

        case 5:
          a = c.stateNode;
          null === b && c.effectTag & 4 && jg(a, c.type, c.memoizedProps, c);
          return;

        case 6:
          return;

        case 4:
          return;

        case 12:
          return;

        case 13:
          Aa && null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && kg(c))));
          return;

        case 19:
        case 17:
        case 20:
        case 21:
          return;
      }

      throw Error(m(163));
    }

    function Ne(a, b, c) {
      "function" === typeof sd && sd(b);

      switch (b.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
          a = b.updateQueue;

          if (null !== a && (a = a.lastEffect, null !== a)) {
            var d = a.next;
            n(97 < c ? 97 : c, function () {
              var a = d;

              do {
                var c = a.destroy;

                if (void 0 !== c) {
                  var e = b;

                  try {
                    c();
                  } catch (C) {
                    Xa(e, C);
                  }
                }

                a = a.next;
              } while (a !== d);
            });
          }

          break;

        case 1:
          Le(b);
          c = b.stateNode;
          "function" === typeof c.componentWillUnmount && gg(b, c);
          break;

        case 5:
          Le(b);
          break;

        case 4:
          ua ? Oe(a, b, c) : Db && lg(b);
      }
    }

    function Pe(a, b, c) {
      for (var d = b;;) {
        if (Ne(a, d, c), null === d.child || ua && 4 === d.tag) {
          if (d === b) break;

          for (; null === d.sibling;) {
            if (null === d.return || d.return === b) return;
            d = d.return;
          }

          d.sibling.return = d.return;
          d = d.sibling;
        } else d.child.return = d, d = d.child;
      }
    }

    function Qe(a) {
      var b = a.alternate;
      a.return = null;
      a.child = null;
      a.memoizedState = null;
      a.updateQueue = null;
      a.dependencies = null;
      a.alternate = null;
      a.firstEffect = null;
      a.lastEffect = null;
      a.pendingProps = null;
      a.memoizedProps = null;
      a.stateNode = null;
      null !== b && Qe(b);
    }

    function lg(a) {
      if (Db) {
        a = a.stateNode.containerInfo;
        var b = Re(a);
        Se(a, b);
      }
    }

    function Te(a) {
      return 5 === a.tag || 3 === a.tag || 4 === a.tag;
    }

    function Ue(a) {
      if (ua) {
        a: {
          for (var b = a.return; null !== b;) {
            if (Te(b)) {
              var c = b;
              break a;
            }

            b = b.return;
          }

          throw Error(m(160));
        }

        b = c.stateNode;

        switch (c.tag) {
          case 5:
            var d = !1;
            break;

          case 3:
            b = b.containerInfo;
            d = !0;
            break;

          case 4:
            b = b.containerInfo;
            d = !0;
            break;

          default:
            throw Error(m(161));
        }

        c.effectTag & 16 && (Ve(b), c.effectTag &= -17);
        c = a;

        a: b: for (;;) {
          for (; null === c.sibling;) {
            if (null === c.return || Te(c.return)) {
              c = null;
              break a;
            }

            c = c.return;
          }

          c.sibling.return = c.return;

          for (c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;) {
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;else c.child.return = c, c = c.child;
          }

          if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
          }
        }

        d ? td(a, c, b) : ud(a, c, b);
      }
    }

    function td(a, b, c) {
      var d = a.tag,
          f = 5 === d || 6 === d;
      if (f) a = f ? a.stateNode : a.stateNode.instance, b ? mg(c, a, b) : ng(c, a);else if (4 !== d && (a = a.child, null !== a)) for (td(a, b, c), a = a.sibling; null !== a;) {
        td(a, b, c), a = a.sibling;
      }
    }

    function ud(a, b, c) {
      var d = a.tag,
          f = 5 === d || 6 === d;
      if (f) a = f ? a.stateNode : a.stateNode.instance, b ? og(c, a, b) : pg(c, a);else if (4 !== d && (a = a.child, null !== a)) for (ud(a, b, c), a = a.sibling; null !== a;) {
        ud(a, b, c), a = a.sibling;
      }
    }

    function Oe(a, b, c) {
      for (var d = b, f = !1, e, g;;) {
        if (!f) {
          f = d.return;

          a: for (;;) {
            if (null === f) throw Error(m(160));
            e = f.stateNode;

            switch (f.tag) {
              case 5:
                g = !1;
                break a;

              case 3:
                e = e.containerInfo;
                g = !0;
                break a;

              case 4:
                e = e.containerInfo;
                g = !0;
                break a;
            }

            f = f.return;
          }

          f = !0;
        }

        if (5 === d.tag || 6 === d.tag) Pe(a, d, c), g ? qg(e, d.stateNode) : rg(e, d.stateNode);else if (4 === d.tag) {
          if (null !== d.child) {
            e = d.stateNode.containerInfo;
            g = !0;
            d.child.return = d;
            d = d.child;
            continue;
          }
        } else if (Ne(a, d, c), null !== d.child) {
          d.child.return = d;
          d = d.child;
          continue;
        }
        if (d === b) break;

        for (; null === d.sibling;) {
          if (null === d.return || d.return === b) return;
          d = d.return;
          4 === d.tag && (f = !1);
        }

        d.sibling.return = d.return;
        d = d.sibling;
      }
    }

    function vd(a, b) {
      if (ua) {
        switch (b.tag) {
          case 0:
          case 11:
          case 14:
          case 15:
          case 22:
            qd(3, b);
            return;

          case 1:
            return;

          case 5:
            var c = b.stateNode;

            if (null != c) {
              var d = b.memoizedProps;
              a = null !== a ? a.memoizedProps : d;
              var f = b.type,
                  e = b.updateQueue;
              b.updateQueue = null;
              null !== e && sg(c, e, f, a, d, b);
            }

            return;

          case 6:
            if (null === b.stateNode) throw Error(m(162));
            c = b.memoizedProps;
            tg(b.stateNode, null !== a ? a.memoizedProps : c, c);
            return;

          case 3:
            Aa && (b = b.stateNode, b.hydrate && (b.hydrate = !1, We(b.containerInfo)));
            return;

          case 12:
            return;

          case 13:
            Xe(b);
            oc(b);
            return;

          case 19:
            oc(b);
            return;

          case 17:
            return;
        }

        throw Error(m(163));
      }

      switch (b.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
          qd(3, b);
          return;

        case 12:
          return;

        case 13:
          Xe(b);
          oc(b);
          return;

        case 19:
          oc(b);
          return;

        case 3:
          Aa && (c = b.stateNode, c.hydrate && (c.hydrate = !1, We(c.containerInfo)));
      }

      a: if (Db) {
        switch (b.tag) {
          case 1:
          case 5:
          case 6:
          case 20:
            break a;

          case 3:
          case 4:
            b = b.stateNode;
            Se(b.containerInfo, b.pendingChildren);
            break a;
        }

        throw Error(m(163));
      }
    }

    function Xe(a) {
      var b = a;
      if (null === a.memoizedState) var c = !1;else c = !0, b = a.child, wd = ja();
      if (ua && null !== b) a: if (a = b, ua) for (b = a;;) {
        if (5 === b.tag) {
          var d = b.stateNode;
          c ? ug(d) : vg(b.stateNode, b.memoizedProps);
        } else if (6 === b.tag) d = b.stateNode, c ? wg(d) : xg(d, b.memoizedProps);else if (13 === b.tag && null !== b.memoizedState && null === b.memoizedState.dehydrated) {
          d = b.child.sibling;
          d.return = b;
          b = d;
          continue;
        } else if (null !== b.child) {
          b.child.return = b;
          b = b.child;
          continue;
        }

        if (b === a) break a;

        for (; null === b.sibling;) {
          if (null === b.return || b.return === a) break a;
          b = b.return;
        }

        b.sibling.return = b.return;
        b = b.sibling;
      }
    }

    function oc(a) {
      var b = a.updateQueue;

      if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new yg());
        b.forEach(function (b) {
          var d = zg.bind(null, a, b);
          c.has(b) || (c.add(b), b.then(d, d));
        });
      }
    }

    function Ye(a, b, c) {
      c = oa(c, null);
      c.tag = 3;
      c.payload = {
        element: null
      };
      var d = b.value;

      c.callback = function () {
        pc || (pc = !0, xd = d);
        pd(a, b);
      };

      return c;
    }

    function Ze(a, b, c) {
      c = oa(c, null);
      c.tag = 3;
      var d = a.type.getDerivedStateFromError;

      if ("function" === typeof d) {
        var f = b.value;

        c.payload = function () {
          pd(a, b);
          return d(f);
        };
      }

      var e = a.stateNode;
      null !== e && "function" === typeof e.componentDidCatch && (c.callback = function () {
        "function" !== typeof d && (null === La ? La = new Set([this]) : La.add(this), pd(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
          componentStack: null !== c ? c : ""
        });
      });
      return c;
    }

    function pa() {
      return (x & (ka | qa)) !== H ? 1073741821 - (ja() / 10 | 0) : 0 !== qc ? qc : qc = 1073741821 - (ja() / 10 | 0);
    }

    function Sa(a, b, c) {
      b = b.mode;
      if (0 === (b & 2)) return 1073741823;
      var d = J();
      if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
      if ((x & ka) !== H) return V;
      if (null !== c) a = da(a, c.timeoutMs | 0 || 5E3, 250);else switch (d) {
        case 99:
          a = 1073741823;
          break;

        case 98:
          a = da(a, 150, 100);
          break;

        case 97:
        case 96:
          a = da(a, 5E3, 250);
          break;

        case 95:
          a = 2;
          break;

        default:
          throw Error(m(326));
      }
      null !== ca && a === V && --a;
      return a;
    }

    function ya(a, b) {
      if (50 < Eb) throw Eb = 0, yd = null, Error(m(185));
      a = rc(a, b);

      if (null !== a) {
        var c = J();
        1073741823 === b ? (x & zd) !== H && (x & (ka | qa)) === H ? Ad(a) : (W(a), x === H && R()) : W(a);
        (x & 4) === H || 98 !== c && 99 !== c || (null === Ya ? Ya = new Map([[a, b]]) : (c = Ya.get(a), (void 0 === c || c > b) && Ya.set(a, b)));
      }
    }

    function rc(a, b) {
      a.expirationTime < b && (a.expirationTime = b);
      var c = a.alternate;
      null !== c && c.expirationTime < b && (c.expirationTime = b);
      var d = a.return,
          f = null;
      if (null === d && 3 === a.tag) f = a.stateNode;else for (; null !== d;) {
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);

        if (null === d.return && 3 === d.tag) {
          f = d.stateNode;
          break;
        }

        d = d.return;
      }
      null !== f && (ca === f && (Ub(b), K === nc && Wa(f, V)), Ke(f, b));
      return f;
    }

    function sc(a) {
      var b = a.lastExpiredTime;
      if (0 !== b) return b;
      b = a.firstPendingTime;
      if (!$e(a, b)) return b;
      var c = a.lastPingedTime;
      a = a.nextKnownPendingLevel;
      a = c > a ? c : a;
      return 2 >= a && b !== a ? 0 : a;
    }

    function W(a) {
      if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = cb(Ad.bind(null, a));else {
        var b = sc(a),
            c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);else {
          var d = pa();
          1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);

          if (null !== c) {
            var f = a.callbackPriority;
            if (a.callbackExpirationTime === b && f >= d) return;
            c !== ce && de(c);
          }

          a.callbackExpirationTime = b;
          a.callbackPriority = d;
          b = 1073741823 === b ? cb(Ad.bind(null, a)) : tb(d, af.bind(null, a), {
            timeout: 10 * (1073741821 - b) - ja()
          });
          a.callbackNode = b;
        }
      }
    }

    function af(a, b) {
      qc = 0;
      if (b) return b = pa(), tc(a, b), W(a), null;
      var c = sc(a);

      if (0 !== c) {
        b = a.callbackNode;
        if ((x & (ka | qa)) !== H) throw Error(m(327));
        Za();
        a === ca && c === V || $a(a, c);

        if (null !== z) {
          var d = x;
          x |= ka;
          var f = bf();

          do {
            try {
              for (; null !== z && !Ag();) {
                z = cf(z);
              }

              break;
            } catch (C) {
              df(a, C);
            }
          } while (1);

          hb = Ha = gb = null;
          x = d;
          uc.current = f;
          if (K === vc) throw b = wc, $a(a, c), Wa(a, c), W(a), b;
          if (null === z) switch (f = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = K, ca = null, d) {
            case Va:
            case vc:
              throw Error(m(345));

            case ef:
              tc(a, 2 < c ? 2 : c);
              break;

            case mc:
              Wa(a, c);
              d = a.lastSuspendedTime;
              c === d && (a.nextKnownPendingLevel = Bd(f));

              if (1073741823 === Ca && (f = wd + ff - ja(), 10 < f)) {
                if (xc) {
                  var e = a.lastPingedTime;

                  if (0 === e || e >= c) {
                    a.lastPingedTime = c;
                    $a(a, c);
                    break;
                  }
                }

                e = sc(a);
                if (0 !== e && e !== c) break;

                if (0 !== d && d !== c) {
                  a.lastPingedTime = d;
                  break;
                }

                a.timeoutHandle = Cd(ab.bind(null, a), f);
                break;
              }

              ab(a);
              break;

            case nc:
              Wa(a, c);
              d = a.lastSuspendedTime;
              c === d && (a.nextKnownPendingLevel = Bd(f));

              if (xc && (f = a.lastPingedTime, 0 === f || f >= c)) {
                a.lastPingedTime = c;
                $a(a, c);
                break;
              }

              f = sc(a);
              if (0 !== f && f !== c) break;

              if (0 !== d && d !== c) {
                a.lastPingedTime = d;
                break;
              }

              1073741823 !== Fb ? d = 10 * (1073741821 - Fb) - ja() : 1073741823 === Ca ? d = 0 : (d = 10 * (1073741821 - Ca) - 5E3, f = ja(), c = 10 * (1073741821 - c) - f, d = f - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * Bg(d / 1960)) - d, c < d && (d = c));

              if (10 < d) {
                a.timeoutHandle = Cd(ab.bind(null, a), d);
                break;
              }

              ab(a);
              break;

            case Dd:
              if (1073741823 !== Ca && null !== yc) {
                e = Ca;
                var g = yc;
                d = g.busyMinDurationMs | 0;
                0 >= d ? d = 0 : (f = g.busyDelayMs | 0, e = ja() - (10 * (1073741821 - e) - (g.timeoutMs | 0 || 5E3)), d = e <= f ? 0 : f + d - e);

                if (10 < d) {
                  Wa(a, c);
                  a.timeoutHandle = Cd(ab.bind(null, a), d);
                  break;
                }
              }

              ab(a);
              break;

            default:
              throw Error(m(329));
          }
          W(a);
          if (a.callbackNode === b) return af.bind(null, a);
        }
      }

      return null;
    }

    function Ad(a) {
      var b = a.lastExpiredTime;
      b = 0 !== b ? b : 1073741823;
      if ((x & (ka | qa)) !== H) throw Error(m(327));
      Za();
      a === ca && b === V || $a(a, b);

      if (null !== z) {
        var c = x;
        x |= ka;
        var d = bf();

        do {
          try {
            for (; null !== z;) {
              z = cf(z);
            }

            break;
          } catch (f) {
            df(a, f);
          }
        } while (1);

        hb = Ha = gb = null;
        x = c;
        uc.current = d;
        if (K === vc) throw c = wc, $a(a, b), Wa(a, b), W(a), c;
        if (null !== z) throw Error(m(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        ca = null;
        ab(a);
        W(a);
      }

      return null;
    }

    function Cg(a, b) {
      tc(a, b);
      W(a);
      (x & (ka | qa)) === H && R();
    }

    function Dg() {
      if (null !== Ya) {
        var a = Ya;
        Ya = null;
        a.forEach(function (a, c) {
          tc(c, a);
          W(c);
        });
        R();
      }
    }

    function gf(a, b) {
      var c = x;
      x |= 1;

      try {
        return a(b);
      } finally {
        x = c, x === H && R();
      }
    }

    function hf(a, b) {
      if ((x & (ka | qa)) !== H) throw Error(m(187));
      var c = x;
      x |= 1;

      try {
        return n(99, a.bind(null, b));
      } finally {
        x = c, R();
      }
    }

    function $a(a, b) {
      a.finishedWork = null;
      a.finishedExpirationTime = 0;
      var c = a.timeoutHandle;
      c !== Ed && (a.timeoutHandle = Ed, Eg(c));
      if (null !== z) for (c = z.return; null !== c;) {
        var d = c;

        switch (d.tag) {
          case 1:
            d = d.type.childContextTypes;
            null !== d && void 0 !== d && na();
            break;

          case 3:
            jb();
            A(S);
            A(N);
            break;

          case 5:
            Tc(d);
            break;

          case 4:
            jb();
            break;

          case 13:
            A(E);
            break;

          case 19:
            A(E);
            break;

          case 10:
            fb(d);
        }

        c = c.return;
      }
      ca = a;
      z = Qa(a.current, null);
      V = b;
      K = Va;
      wc = null;
      Fb = Ca = 1073741823;
      yc = null;
      Cb = 0;
      xc = !1;
    }

    function df(a, b) {
      do {
        try {
          hb = Ha = gb = null;
          bc.current = cc;
          if (dc) for (var c = G.memoizedState; null !== c;) {
            var d = c.queue;
            null !== d && (d.pending = null);
            c = c.next;
          }
          Ka = 0;
          O = P = G = null;
          dc = !1;
          if (null === z || null === z.return) return K = vc, wc = b, z = null;

          a: {
            var f = a,
                e = z.return,
                g = z,
                p = b;
            b = V;
            g.effectTag |= 2048;
            g.firstEffect = g.lastEffect = null;

            if (null !== p && "object" === typeof p && "function" === typeof p.then) {
              var h = p;

              if (0 === (g.mode & 2)) {
                var m = g.alternate;
                m ? (g.updateQueue = m.updateQueue, g.memoizedState = m.memoizedState, g.expirationTime = m.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
              }

              var t = 0 !== (E.current & 1),
                  n = e;

              do {
                var q;

                if (q = 13 === n.tag) {
                  var x = n.memoizedState;
                  if (null !== x) q = null !== x.dehydrated ? !0 : !1;else {
                    var v = n.memoizedProps;
                    q = void 0 === v.fallback ? !1 : !0 !== v.unstable_avoidThisFallback ? !0 : t ? !1 : !0;
                  }
                }

                if (q) {
                  var w = n.updateQueue;

                  if (null === w) {
                    var y = new Set();
                    y.add(h);
                    n.updateQueue = y;
                  } else w.add(h);

                  if (0 === (n.mode & 2)) {
                    n.effectTag |= 64;
                    g.effectTag &= -2981;
                    if (1 === g.tag) if (null === g.alternate) g.tag = 17;else {
                      var A = oa(1073741823, null);
                      A.tag = 2;
                      F(g, A);
                    }
                    g.expirationTime = 1073741823;
                    break a;
                  }

                  p = void 0;
                  g = b;
                  var B = f.pingCache;
                  null === B ? (B = f.pingCache = new Fg(), p = new Set(), B.set(h, p)) : (p = B.get(h), void 0 === p && (p = new Set(), B.set(h, p)));

                  if (!p.has(g)) {
                    p.add(g);
                    var M = Gg.bind(null, f, h, g);
                    h.then(M, M);
                  }

                  n.effectTag |= 4096;
                  n.expirationTime = b;
                  break a;
                }

                n = n.return;
              } while (null !== n);

              p = Error((r(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + Ea(g));
            }

            K !== Dd && (K = ef);
            p = od(p, g);
            n = e;

            do {
              switch (n.tag) {
                case 3:
                  h = p;
                  n.effectTag |= 4096;
                  n.expirationTime = b;
                  var Z = Ye(n, h, b);
                  ee(n, Z);
                  break a;

                case 1:
                  h = p;
                  var ma = n.type,
                      Q = n.stateNode;

                  if (0 === (n.effectTag & 64) && ("function" === typeof ma.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === La || !La.has(Q)))) {
                    n.effectTag |= 4096;
                    n.expirationTime = b;
                    var I = Ze(n, h, b);
                    ee(n, I);
                    break a;
                  }

              }

              n = n.return;
            } while (null !== n);
          }

          z = jf(z);
        } catch (Qf) {
          b = Qf;
          continue;
        }

        break;
      } while (1);
    }

    function bf() {
      var a = uc.current;
      uc.current = cc;
      return null === a ? cc : a;
    }

    function fe(a, b) {
      a < Ca && 2 < a && (Ca = a);
      null !== b && a < Fb && 2 < a && (Fb = a, yc = b);
    }

    function Ub(a) {
      a > Cb && (Cb = a);
    }

    function cf(a) {
      var b = Hg(a.alternate, a, V);
      a.memoizedProps = a.pendingProps;
      null === b && (b = jf(a));
      kf.current = null;
      return b;
    }

    function jf(a) {
      z = a;

      do {
        var b = z.alternate;
        a = z.return;

        if (0 === (z.effectTag & 2048)) {
          b = bg(b, z, V);

          if (1 === V || 1 !== z.childExpirationTime) {
            for (var c = 0, d = z.child; null !== d;) {
              var f = d.expirationTime,
                  e = d.childExpirationTime;
              f > c && (c = f);
              e > c && (c = e);
              d = d.sibling;
            }

            z.childExpirationTime = c;
          }

          if (null !== b) return b;
          null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = z.firstEffect), null !== z.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = z.firstEffect), a.lastEffect = z.lastEffect), 1 < z.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = z : a.firstEffect = z, a.lastEffect = z));
        } else {
          b = fg(z);
          if (null !== b) return b.effectTag &= 2047, b;
          null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }

        b = z.sibling;
        if (null !== b) return b;
        z = a;
      } while (null !== z);

      K === Va && (K = Dd);
      return null;
    }

    function Bd(a) {
      var b = a.expirationTime;
      a = a.childExpirationTime;
      return b > a ? b : a;
    }

    function ab(a) {
      var b = J();
      n(99, Ig.bind(null, a, b));
      return null;
    }

    function Ig(a, b) {
      do {
        Za();
      } while (null !== Gb);

      if ((x & (ka | qa)) !== H) throw Error(m(327));
      var c = a.finishedWork,
          d = a.finishedExpirationTime;
      if (null === c) return null;
      a.finishedWork = null;
      a.finishedExpirationTime = 0;
      if (c === a.current) throw Error(m(177));
      a.callbackNode = null;
      a.callbackExpirationTime = 0;
      a.callbackPriority = 90;
      a.nextKnownPendingLevel = 0;
      var f = Bd(c);
      a.firstPendingTime = f;
      d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
      d <= a.lastPingedTime && (a.lastPingedTime = 0);
      d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
      a === ca && (z = ca = null, V = 0);
      1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, f = c.firstEffect) : f = c : f = c.firstEffect;

      if (null !== f) {
        var e = x;
        x |= qa;
        kf.current = null;
        Jg(a.containerInfo);
        q = f;

        do {
          try {
            Kg();
          } catch (yb) {
            if (null === q) throw Error(m(330));
            Xa(q, yb);
            q = q.nextEffect;
          }
        } while (null !== q);

        q = f;

        do {
          try {
            for (var g = a, p = b; null !== q;) {
              var h = q.effectTag;
              h & 16 && ua && Ve(q.stateNode);

              if (h & 128) {
                var n = q.alternate;

                if (null !== n) {
                  var t = n.ref;
                  null !== t && ("function" === typeof t ? t(null) : t.current = null);
                }
              }

              switch (h & 1038) {
                case 2:
                  Ue(q);
                  q.effectTag &= -3;
                  break;

                case 6:
                  Ue(q);
                  q.effectTag &= -3;
                  vd(q.alternate, q);
                  break;

                case 1024:
                  q.effectTag &= -1025;
                  break;

                case 1028:
                  q.effectTag &= -1025;
                  vd(q.alternate, q);
                  break;

                case 4:
                  vd(q.alternate, q);
                  break;

                case 8:
                  var r = g,
                      F = q,
                      v = p;
                  ua ? Oe(r, F, v) : Pe(r, F, v);
                  Qe(F);
              }

              q = q.nextEffect;
            }
          } catch (yb) {
            if (null === q) throw Error(m(330));
            Xa(q, yb);
            q = q.nextEffect;
          }
        } while (null !== q);

        Lg(a.containerInfo);
        a.current = c;
        q = f;

        do {
          try {
            for (h = a; null !== q;) {
              var w = q.effectTag;
              w & 36 && ig(h, q.alternate, q);

              if (w & 128) {
                n = void 0;
                var y = q.ref;

                if (null !== y) {
                  var oa = q.stateNode;

                  switch (q.tag) {
                    case 5:
                      n = rd(oa);
                      break;

                    default:
                      n = oa;
                  }

                  "function" === typeof y ? y(n) : y.current = n;
                }
              }

              q = q.nextEffect;
            }
          } catch (yb) {
            if (null === q) throw Error(m(330));
            Xa(q, yb);
            q = q.nextEffect;
          }
        } while (null !== q);

        q = null;
        Mg();
        x = e;
      } else a.current = c;

      if (zc) zc = !1, Gb = a, Hb = b;else for (q = f; null !== q;) {
        b = q.nextEffect, q.nextEffect = null, q = b;
      }
      b = a.firstPendingTime;
      0 === b && (La = null);
      1073741823 === b ? a === yd ? Eb++ : (Eb = 0, yd = a) : Eb = 0;
      "function" === typeof Fd && Fd(c.stateNode, d);
      W(a);
      if (pc) throw pc = !1, a = xd, xd = null, a;
      if ((x & zd) !== H) return null;
      R();
      return null;
    }

    function Kg() {
      for (; null !== q;) {
        var a = q.effectTag;
        0 !== (a & 256) && hg(q.alternate, q);
        0 === (a & 512) || zc || (zc = !0, tb(97, function () {
          Za();
          return null;
        }));
        q = q.nextEffect;
      }
    }

    function Za() {
      if (90 !== Hb) {
        var a = 97 < Hb ? 97 : Hb;
        Hb = 90;
        return n(a, Ng);
      }
    }

    function Ng() {
      if (null === Gb) return !1;
      var a = Gb;
      Gb = null;
      if ((x & (ka | qa)) !== H) throw Error(m(331));
      var b = x;
      x |= qa;

      for (a = a.current.firstEffect; null !== a;) {
        try {
          var c = a;
          if (0 !== (c.effectTag & 512)) switch (c.tag) {
            case 0:
            case 11:
            case 15:
            case 22:
              qd(5, c), Me(5, c);
          }
        } catch (d) {
          if (null === a) throw Error(m(330));
          Xa(a, d);
        }

        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
      }

      x = b;
      R();
      return !0;
    }

    function lf(a, b, c) {
      b = od(c, b);
      b = Ye(a, b, 1073741823);
      F(a, b);
      a = rc(a, 1073741823);
      null !== a && W(a);
    }

    function Xa(a, b) {
      if (3 === a.tag) lf(a, a, b);else for (var c = a.return; null !== c;) {
        if (3 === c.tag) {
          lf(c, a, b);
          break;
        } else if (1 === c.tag) {
          var d = c.stateNode;

          if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === La || !La.has(d))) {
            a = od(b, a);
            a = Ze(c, a, 1073741823);
            F(c, a);
            c = rc(c, 1073741823);
            null !== c && W(c);
            break;
          }
        }

        c = c.return;
      }
    }

    function Gg(a, b, c) {
      var d = a.pingCache;
      null !== d && d.delete(b);
      ca === a && V === c ? K === nc || K === mc && 1073741823 === Ca && ja() - wd < ff ? $a(a, V) : xc = !0 : $e(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, W(a)));
    }

    function zg(a, b) {
      var c = a.stateNode;
      null !== c && c.delete(b);
      b = 0;
      0 === b && (b = pa(), b = Sa(b, a, null));
      a = rc(a, b);
      null !== a && W(a);
    }

    function Og(a) {
      if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
      var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (b.isDisabled || !b.supportsFiber) return !0;

      try {
        var c = b.inject(a);

        Fd = function Fd(a) {
          try {
            b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
          } catch (f) {}
        };

        sd = function sd(a) {
          try {
            b.onCommitFiberUnmount(c, a);
          } catch (f) {}
        };
      } catch (d) {}

      return !0;
    }

    function Pg(a, b, c, d) {
      this.tag = a;
      this.key = c;
      this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
      this.index = 0;
      this.ref = null;
      this.pendingProps = b;
      this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
      this.mode = d;
      this.effectTag = 0;
      this.lastEffect = this.firstEffect = this.nextEffect = null;
      this.childExpirationTime = this.expirationTime = 0;
      this.alternate = null;
    }

    function ta(a, b, c, d) {
      return new Pg(a, b, c, d);
    }

    function hd(a) {
      a = a.prototype;
      return !(!a || !a.isReactComponent);
    }

    function Qg(a) {
      if ("function" === typeof a) return hd(a) ? 1 : 0;

      if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Ic) return 11;
        if (a === Jc) return 14;
      }

      return 2;
    }

    function Qa(a, b) {
      var c = a.alternate;
      null === c ? (c = ta(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
      c.childExpirationTime = a.childExpirationTime;
      c.expirationTime = a.expirationTime;
      c.child = a.child;
      c.memoizedProps = a.memoizedProps;
      c.memoizedState = a.memoizedState;
      c.updateQueue = a.updateQueue;
      b = a.dependencies;
      c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
      };
      c.sibling = a.sibling;
      c.index = a.index;
      c.ref = a.ref;
      return c;
    }

    function Yb(a, b, c, d, f, e) {
      var g = 2;
      d = a;
      if ("function" === typeof a) hd(a) && (g = 1);else if ("string" === typeof a) g = 5;else a: switch (a) {
        case Na:
          return Ja(c.children, f, e, b);

        case Rg:
          g = 8;
          f |= 7;
          break;

        case Ud:
          g = 8;
          f |= 1;
          break;

        case Ob:
          return a = ta(12, c, b, f | 8), a.elementType = Ob, a.type = Ob, a.expirationTime = e, a;

        case Pb:
          return a = ta(13, c, b, f), a.type = Pb, a.elementType = Pb, a.expirationTime = e, a;

        case Hc:
          return a = ta(19, c, b, f), a.elementType = Hc, a.expirationTime = e, a;

        default:
          if ("object" === typeof a && null !== a) switch (a.$$typeof) {
            case Wd:
              g = 10;
              break a;

            case Vd:
              g = 9;
              break a;

            case Ic:
              g = 11;
              break a;

            case Jc:
              g = 14;
              break a;

            case Yd:
              g = 16;
              d = null;
              break a;

            case Xd:
              g = 22;
              break a;
          }
          throw Error(m(130, null == a ? a : typeof a, ""));
      }
      b = ta(g, c, b, f);
      b.elementType = a;
      b.type = d;
      b.expirationTime = e;
      return b;
    }

    function Ja(a, b, c, d) {
      a = ta(7, a, d, b);
      a.expirationTime = c;
      return a;
    }

    function Qc(a, b, c) {
      a = ta(6, a, null, b);
      a.expirationTime = c;
      return a;
    }

    function Rc(a, b, c) {
      b = ta(4, null !== a.children ? a.children : [], a.key, b);
      b.expirationTime = c;
      b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
      };
      return b;
    }

    function Sg(a, b, c) {
      this.tag = b;
      this.current = null;
      this.containerInfo = a;
      this.pingCache = this.pendingChildren = null;
      this.finishedExpirationTime = 0;
      this.finishedWork = null;
      this.timeoutHandle = Ed;
      this.pendingContext = this.context = null;
      this.hydrate = c;
      this.callbackNode = null;
      this.callbackPriority = 90;
      this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
    }

    function $e(a, b) {
      var c = a.firstSuspendedTime;
      a = a.lastSuspendedTime;
      return 0 !== c && c >= b && a <= b;
    }

    function Wa(a, b) {
      var c = a.firstSuspendedTime,
          d = a.lastSuspendedTime;
      c < b && (a.firstSuspendedTime = b);
      if (d > b || 0 === c) a.lastSuspendedTime = b;
      b <= a.lastPingedTime && (a.lastPingedTime = 0);
      b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    }

    function Ke(a, b) {
      b > a.firstPendingTime && (a.firstPendingTime = b);
      var c = a.firstSuspendedTime;
      0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
    }

    function tc(a, b) {
      var c = a.lastExpiredTime;
      if (0 === c || c > b) a.lastExpiredTime = b;
    }

    function Tg(a) {
      if (null === Ac) try {
        var b = ("require" + Math.random()).slice(0, 7);
        Ac = (e && e[b])("timers").setImmediate;
      } catch (c) {
        Ac = function Ac(a) {
          var b = new MessageChannel();
          b.port1.onmessage = a;
          b.port2.postMessage(void 0);
        };
      }
      return Ac(a);
    }

    function mf(a) {
      var b = a._reactInternalFiber;

      if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(m(188));
        throw Error(m(268, Object.keys(a)));
      }

      a = ma(b);
      return null === a ? null : a.stateNode;
    }

    function nf(a, b) {
      a = a.memoizedState;
      null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
    }

    function Bc(a, b) {
      nf(a, b);
      (a = a.alternate) && nf(a, b);
    }

    function of(a) {
      try {
        Gd(), Tg(function () {
          Gd() ? of(a) : a();
        });
      } catch (b) {
        a(b);
      }
    }

    var rb = require$$0,
        pf = React,
        X = require$$2,
        la = pf.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    la.hasOwnProperty("ReactCurrentDispatcher") || (la.ReactCurrentDispatcher = {
      current: null
    });
    la.hasOwnProperty("ReactCurrentBatchConfig") || (la.ReactCurrentBatchConfig = {
      suspense: null
    });
    var Y = "function" === typeof Symbol && Symbol.for,
        Zb = Y ? Symbol.for("react.element") : 60103,
        pb = Y ? Symbol.for("react.portal") : 60106,
        Na = Y ? Symbol.for("react.fragment") : 60107,
        Ud = Y ? Symbol.for("react.strict_mode") : 60108,
        Ob = Y ? Symbol.for("react.profiler") : 60114,
        Wd = Y ? Symbol.for("react.provider") : 60109,
        Vd = Y ? Symbol.for("react.context") : 60110,
        Rg = Y ? Symbol.for("react.concurrent_mode") : 60111,
        Ic = Y ? Symbol.for("react.forward_ref") : 60112,
        Pb = Y ? Symbol.for("react.suspense") : 60113,
        Hc = Y ? Symbol.for("react.suspense_list") : 60120,
        Jc = Y ? Symbol.for("react.memo") : 60115,
        Yd = Y ? Symbol.for("react.lazy") : 60116,
        Xd = Y ? Symbol.for("react.block") : 60121,
        Td = "function" === typeof Symbol && Symbol.iterator,
        rd = g.getPublicInstance,
        Rf = g.getRootHostContext,
        Sf = g.getChildHostContext,
        Jg = g.prepareForCommit,
        Lg = g.resetAfterCommit,
        dg = g.createInstance,
        Hd = g.appendInitialChild,
        Ie = g.finalizeInitialChildren,
        qf = g.prepareUpdate,
        ed = g.shouldSetTextContent,
        rf = g.shouldDeprioritizeSubtree,
        Je = g.createTextInstance,
        Cd = g.setTimeout,
        Eg = g.clearTimeout,
        Ed = g.noTimeout,
        Nc = g.isPrimaryRenderer,
        ua = g.supportsMutation,
        Db = g.supportsPersistence,
        Aa = g.supportsHydration,
        pg = g.appendChild,
        ng = g.appendChildToContainer,
        tg = g.commitTextUpdate,
        jg = g.commitMount,
        sg = g.commitUpdate,
        og = g.insertBefore,
        mg = g.insertInContainerBefore,
        rg = g.removeChild,
        qg = g.removeChildFromContainer,
        Ve = g.resetTextContent,
        ug = g.hideInstance,
        wg = g.hideTextInstance,
        vg = g.unhideInstance,
        xg = g.unhideTextInstance,
        Ug = g.cloneInstance,
        Re = g.createContainerChildSet,
        sf = g.appendChildToContainerChildSet,
        Vg = g.finalizeContainerChildren,
        Se = g.replaceContainerChildren,
        tf = g.cloneHiddenInstance,
        uf = g.cloneHiddenTextInstance,
        Yf = g.canHydrateInstance,
        Zf = g.canHydrateTextInstance,
        Tf = g.isSuspenseInstancePending,
        Uf = g.isSuspenseInstanceFallback,
        dd = g.getNextHydratableSibling,
        xe = g.getFirstHydratableChild,
        cg = g.hydrateInstance,
        eg = g.hydrateTextInstance,
        $f = g.getNextHydratableInstanceAfterSuspenseInstance,
        We = g.commitHydratedContainer,
        kg = g.commitHydratedSuspenseInstance,
        Mf = /^(.*)[\\\/]/,
        Kc = [],
        bb = -1,
        Fa = {},
        N = {
      current: Fa
    },
        S = {
      current: !1
    },
        Oa = Fa,
        Of = X.unstable_runWithPriority,
        Lc = X.unstable_scheduleCallback,
        de = X.unstable_cancelCallback,
        vf = X.unstable_requestPaint,
        Id = X.unstable_now,
        Nf = X.unstable_getCurrentPriorityLevel,
        Qb = X.unstable_ImmediatePriority,
        Zd = X.unstable_UserBlockingPriority,
        $d = X.unstable_NormalPriority,
        ae = X.unstable_LowPriority,
        be = X.unstable_IdlePriority,
        ce = {},
        Ag = X.unstable_shouldYield,
        Mg = void 0 !== vf ? vf : function () {},
        wa = null,
        Sb = null,
        Mc = !1,
        wf = Id(),
        ja = 1E4 > wf ? Id : function () {
      return Id() - wf;
    },
        Pa = "function" === typeof Object.is ? Object.is : db,
        Pf = Object.prototype.hasOwnProperty,
        Tb = {
      current: null
    },
        gb = null,
        Ha = null,
        hb = null,
        Ia = !1,
        Bb = la.ReactCurrentBatchConfig,
        ke = new pf.Component().refs,
        Wb = {
      isMounted: function isMounted(a) {
        return (a = a._reactInternalFiber) ? w(a) === a : !1;
      },
      enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternalFiber;
        var d = pa(),
            f = Bb.suspense;
        d = Sa(d, a, f);
        f = oa(d, f);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        F(a, f);
        ya(a, d);
      },
      enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternalFiber;
        var d = pa(),
            f = Bb.suspense;
        d = Sa(d, a, f);
        f = oa(d, f);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        F(a, f);
        ya(a, d);
      },
      enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternalFiber;
        var c = pa(),
            d = Bb.suspense;
        c = Sa(c, a, d);
        d = oa(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        F(a, d);
        ya(a, c);
      }
    },
        $b = Array.isArray,
        mb = le(!0),
        gd = le(!1),
        zb = {},
        ha = {
      current: zb
    },
        Ab = {
      current: zb
    },
        ib = {
      current: zb
    },
        E = {
      current: 0
    },
        bc = la.ReactCurrentDispatcher,
        ia = la.ReactCurrentBatchConfig,
        Ka = 0,
        G = null,
        P = null,
        O = null,
        dc = !1,
        cc = {
      readContext: U,
      useCallback: aa,
      useContext: aa,
      useEffect: aa,
      useImperativeHandle: aa,
      useLayoutEffect: aa,
      useMemo: aa,
      useReducer: aa,
      useRef: aa,
      useState: aa,
      useDebugValue: aa,
      useResponder: aa,
      useDeferredValue: aa,
      useTransition: aa
    },
        Vf = {
      readContext: U,
      useCallback: te,
      useContext: U,
      useEffect: pe,
      useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([a]) : null;
        return Zc(4, 2, re.bind(null, b, a), c);
      },
      useLayoutEffect: function useLayoutEffect(a, b) {
        return Zc(4, 2, a, b);
      },
      useMemo: function useMemo(a, b) {
        var c = kb();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [a, b];
        return a;
      },
      useReducer: function useReducer(a, b, c) {
        var d = kb();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
          pending: null,
          dispatch: null,
          lastRenderedReducer: a,
          lastRenderedState: b
        };
        a = a.dispatch = ne.bind(null, G, a);
        return [d.memoizedState, a];
      },
      useRef: function useRef(a) {
        var b = kb();
        a = {
          current: a
        };
        return b.memoizedState = a;
      },
      useState: Xc,
      useDebugValue: ad,
      useResponder: Uc,
      useDeferredValue: function useDeferredValue(a, b) {
        var c = Xc(a),
            d = c[0],
            f = c[1];
        pe(function () {
          var c = ia.suspense;
          ia.suspense = void 0 === b ? null : b;

          try {
            f(a);
          } finally {
            ia.suspense = c;
          }
        }, [a, b]);
        return d;
      },
      useTransition: function useTransition(a) {
        var b = Xc(!1),
            c = b[0];
        b = b[1];
        return [te(bd.bind(null, b, a), [b, a]), c];
      }
    },
        Wf = {
      readContext: U,
      useCallback: hc,
      useContext: U,
      useEffect: gc,
      useImperativeHandle: se,
      useLayoutEffect: qe,
      useMemo: ue,
      useReducer: ec,
      useRef: oe,
      useState: function useState() {
        return ec(Ra);
      },
      useDebugValue: ad,
      useResponder: Uc,
      useDeferredValue: function useDeferredValue(a, b) {
        var c = ec(Ra),
            d = c[0],
            f = c[1];
        gc(function () {
          var c = ia.suspense;
          ia.suspense = void 0 === b ? null : b;

          try {
            f(a);
          } finally {
            ia.suspense = c;
          }
        }, [a, b]);
        return d;
      },
      useTransition: function useTransition(a) {
        var b = ec(Ra),
            c = b[0];
        b = b[1];
        return [hc(bd.bind(null, b, a), [b, a]), c];
      }
    },
        Xf = {
      readContext: U,
      useCallback: hc,
      useContext: U,
      useEffect: gc,
      useImperativeHandle: se,
      useLayoutEffect: qe,
      useMemo: ue,
      useReducer: fc,
      useRef: oe,
      useState: function useState() {
        return fc(Ra);
      },
      useDebugValue: ad,
      useResponder: Uc,
      useDeferredValue: function useDeferredValue(a, b) {
        var c = fc(Ra),
            d = c[0],
            f = c[1];
        gc(function () {
          var c = ia.suspense;
          ia.suspense = void 0 === b ? null : b;

          try {
            f(a);
          } finally {
            ia.suspense = c;
          }
        }, [a, b]);
        return d;
      },
      useTransition: function useTransition(a) {
        var b = fc(Ra),
            c = b[0];
        b = b[1];
        return [hc(bd.bind(null, b, a), [b, a]), c];
      }
    },
        za = null,
        Ua = null,
        Ta = !1,
        ag = la.ReactCurrentOwner,
        ra = !1,
        kd = {
      dehydrated: null,
      retryTime: 0
    };

    if (ua) {
      var _lc = function lc(a, b) {
        for (var c = b.child; null !== c;) {
          if (5 === c.tag || 6 === c.tag) Hd(a, c.stateNode);else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
          }
          if (c === b) break;

          for (; null === c.sibling;) {
            if (null === c.return || c.return === b) return;
            c = c.return;
          }

          c.sibling.return = c.return;
          c = c.sibling;
        }
      };

      var kc = function kc() {};

      var md = function md(a, b, c, d, f) {
        a = a.memoizedProps;

        if (a !== d) {
          var e = b.stateNode,
              g = sa(ha.current);
          c = qf(e, c, a, d, f, g);
          if (b.updateQueue = c) b.effectTag |= 4;
        }
      };

      var nd = function nd(a, b, c, d) {
        c !== d && (b.effectTag |= 4);
      };
    } else if (Db) {
      _lc = function lc(a, b, c, d) {
        for (var f = b.child; null !== f;) {
          if (5 === f.tag) {
            var e = f.stateNode;
            c && d && (e = tf(e, f.type, f.memoizedProps, f));
            Hd(a, e);
          } else if (6 === f.tag) e = f.stateNode, c && d && (e = uf(e, f.memoizedProps, f)), Hd(a, e);else if (4 !== f.tag) {
            if (13 === f.tag && 0 !== (f.effectTag & 4) && (e = null !== f.memoizedState)) {
              var g = f.child;

              if (null !== g && (null !== g.child && (g.child.return = g, _lc(a, g, !0, e)), e = g.sibling, null !== e)) {
                e.return = f;
                f = e;
                continue;
              }
            }

            if (null !== f.child) {
              f.child.return = f;
              f = f.child;
              continue;
            }
          }

          if (f === b) break;

          for (; null === f.sibling;) {
            if (null === f.return || f.return === b) return;
            f = f.return;
          }

          f.sibling.return = f.return;
          f = f.sibling;
        }
      };

      var xf = function xf(a, b, c, d) {
        for (var f = b.child; null !== f;) {
          if (5 === f.tag) {
            var e = f.stateNode;
            c && d && (e = tf(e, f.type, f.memoizedProps, f));
            sf(a, e);
          } else if (6 === f.tag) e = f.stateNode, c && d && (e = uf(e, f.memoizedProps, f)), sf(a, e);else if (4 !== f.tag) {
            if (13 === f.tag && 0 !== (f.effectTag & 4) && (e = null !== f.memoizedState)) {
              var g = f.child;

              if (null !== g && (null !== g.child && (g.child.return = g, xf(a, g, !0, e)), e = g.sibling, null !== e)) {
                e.return = f;
                f = e;
                continue;
              }
            }

            if (null !== f.child) {
              f.child.return = f;
              f = f.child;
              continue;
            }
          }

          if (f === b) break;

          for (; null === f.sibling;) {
            if (null === f.return || f.return === b) return;
            f = f.return;
          }

          f.sibling.return = f.return;
          f = f.sibling;
        }
      };

      kc = function kc(a) {
        var b = a.stateNode;

        if (null !== a.firstEffect) {
          var c = b.containerInfo,
              d = Re(c);
          xf(d, a, !1, !1);
          b.pendingChildren = d;
          a.effectTag |= 4;
          Vg(c, d);
        }
      };

      md = function md(a, b, c, d, f) {
        var e = a.stateNode,
            g = a.memoizedProps;
        if ((a = null === b.firstEffect) && g === d) b.stateNode = e;else {
          var p = b.stateNode,
              h = sa(ha.current),
              m = null;
          g !== d && (m = qf(p, c, g, d, f, h));
          a && null === m ? b.stateNode = e : (e = Ug(e, m, c, g, d, b, a, p), Ie(e, c, d, f, h) && (b.effectTag |= 4), b.stateNode = e, a ? b.effectTag |= 4 : _lc(e, b, !1, !1));
        }
      };

      nd = function nd(a, b, c, d) {
        c !== d ? (a = sa(ib.current), c = sa(ha.current), b.stateNode = Je(d, a, c, b), b.effectTag |= 4) : b.stateNode = a.stateNode;
      };
    } else kc = function kc() {}, md = function md() {}, nd = function nd() {};

    var yg = "function" === typeof WeakSet ? WeakSet : Set,
        Fg = "function" === typeof WeakMap ? WeakMap : Map,
        Bg = Math.ceil,
        uc = la.ReactCurrentDispatcher,
        kf = la.ReactCurrentOwner,
        H = 0,
        zd = 8,
        ka = 16,
        qa = 32,
        Va = 0,
        vc = 1,
        ef = 2,
        mc = 3,
        nc = 4,
        Dd = 5,
        x = H,
        ca = null,
        z = null,
        V = 0,
        K = Va,
        wc = null,
        Ca = 1073741823,
        Fb = 1073741823,
        yc = null,
        Cb = 0,
        xc = !1,
        wd = 0,
        ff = 500,
        q = null,
        pc = !1,
        xd = null,
        La = null,
        zc = !1,
        Gb = null,
        Hb = 90,
        Ya = null,
        Eb = 0,
        yd = null,
        qc = 0;

    var Hg = function Hg(a, b, c) {
      var d = b.expirationTime;

      if (null !== a) {
        var f = b.pendingProps;
        if (a.memoizedProps !== f || S.current) ra = !0;else {
          if (d < c) {
            ra = !1;

            switch (b.tag) {
              case 3:
                Ee(b);
                fd();
                break;

              case 5:
                me(b);
                if (b.mode & 4 && 1 !== c && rf(b.type, f)) return b.expirationTime = b.childExpirationTime = 1, null;
                break;

              case 1:
                I(b.type) && va(b);
                break;

              case 4:
                Sc(b, b.stateNode.containerInfo);
                break;

              case 10:
                vb(b, b.memoizedProps.value);
                break;

              case 13:
                if (null !== b.memoizedState) {
                  d = b.child.childExpirationTime;
                  if (0 !== d && d >= c) return Fe(a, b, c);
                  B(E, E.current & 1);
                  b = Ba(a, b, c);
                  return null !== b ? b.sibling : null;
                }

                B(E, E.current & 1);
                break;

              case 19:
                d = b.childExpirationTime >= c;

                if (0 !== (a.effectTag & 64)) {
                  if (d) return He(a, b, c);
                  b.effectTag |= 64;
                }

                f = b.memoizedState;
                null !== f && (f.rendering = null, f.tail = null);
                B(E, E.current);
                if (!d) return null;
            }

            return Ba(a, b, c);
          }

          ra = !1;
        }
      } else ra = !1;

      b.expirationTime = 0;

      switch (b.tag) {
        case 2:
          d = b.type;
          null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
          a = b.pendingProps;
          f = Z(b, N.current);
          ea(b, c);
          f = Wc(null, b, d, a, f, c);
          b.effectTag |= 1;

          if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) {
            b.tag = 1;
            b.memoizedState = null;
            b.updateQueue = null;

            if (I(d)) {
              var e = !0;
              va(b);
            } else e = !1;

            b.memoizedState = null !== f.state && void 0 !== f.state ? f.state : null;
            p(b);
            var g = d.getDerivedStateFromProps;
            "function" === typeof g && Vb(b, d, g, a);
            f.updater = Wb;
            b.stateNode = f;
            f._reactInternalFiber = b;
            Pc(b, d, a, c);
            b = jd(null, b, d, !0, e, c);
          } else b.tag = 0, ba(null, b, f, c), b = b.child;

          return b;

        case 16:
          a: {
            f = b.elementType;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            y(f);
            if (1 !== f._status) throw f._result;
            f = f._result;
            b.type = f;
            e = b.tag = Qg(f);
            a = T(f, a);

            switch (e) {
              case 0:
                b = id(null, b, f, a, c);
                break a;

              case 1:
                b = De(null, b, f, a, c);
                break a;

              case 11:
                b = ze(null, b, f, a, c);
                break a;

              case 14:
                b = Ae(null, b, f, T(f.type, a), d, c);
                break a;
            }

            throw Error(m(306, f, ""));
          }

          return b;

        case 0:
          return d = b.type, f = b.pendingProps, f = b.elementType === d ? f : T(d, f), id(a, b, d, f, c);

        case 1:
          return d = b.type, f = b.pendingProps, f = b.elementType === d ? f : T(d, f), De(a, b, d, f, c);

        case 3:
          Ee(b);
          d = b.updateQueue;
          if (null === a || null === d) throw Error(m(282));
          d = b.pendingProps;
          f = b.memoizedState;
          f = null !== f ? f.element : null;
          t(a, b);
          wb(b, d, null, c);
          d = b.memoizedState.element;
          if (d === f) fd(), b = Ba(a, b, c);else {
            if (f = b.stateNode.hydrate) Aa ? (Ua = xe(b.stateNode.containerInfo), za = b, f = Ta = !0) : f = !1;
            if (f) for (c = gd(b, null, d, c), b.child = c; c;) {
              c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
            } else ba(a, b, d, c), fd();
            b = b.child;
          }
          return b;

        case 5:
          return me(b), null === a && cd(b), d = b.type, f = b.pendingProps, e = null !== a ? a.memoizedProps : null, g = f.children, ed(d, f) ? g = null : null !== e && ed(d, e) && (b.effectTag |= 16), Ce(a, b), b.mode & 4 && 1 !== c && rf(d, f) ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (ba(a, b, g, c), b = b.child), b;

        case 6:
          return null === a && cd(b), null;

        case 13:
          return Fe(a, b, c);

        case 4:
          return Sc(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = mb(b, null, d, c) : ba(a, b, d, c), b.child;

        case 11:
          return d = b.type, f = b.pendingProps, f = b.elementType === d ? f : T(d, f), ze(a, b, d, f, c);

        case 7:
          return ba(a, b, b.pendingProps, c), b.child;

        case 8:
          return ba(a, b, b.pendingProps.children, c), b.child;

        case 12:
          return ba(a, b, b.pendingProps.children, c), b.child;

        case 10:
          a: {
            d = b.type._context;
            f = b.pendingProps;
            g = b.memoizedProps;
            e = f.value;
            vb(b, e);

            if (null !== g) {
              var h = g.value;
              e = Pa(h, e) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, e) : 1073741823) | 0;

              if (0 === e) {
                if (g.children === f.children && !S.current) {
                  b = Ba(a, b, c);
                  break a;
                }
              } else for (h = b.child, null !== h && (h.return = b); null !== h;) {
                var n = h.dependencies;

                if (null !== n) {
                  g = h.child;

                  for (var q = n.firstContext; null !== q;) {
                    if (q.context === d && 0 !== (q.observedBits & e)) {
                      1 === h.tag && (q = oa(c, null), q.tag = 2, F(h, q));
                      h.expirationTime < c && (h.expirationTime = c);
                      q = h.alternate;
                      null !== q && q.expirationTime < c && (q.expirationTime = c);
                      xa(h.return, c);
                      n.expirationTime < c && (n.expirationTime = c);
                      break;
                    }

                    q = q.next;
                  }
                } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;

                if (null !== g) g.return = h;else for (g = h; null !== g;) {
                  if (g === b) {
                    g = null;
                    break;
                  }

                  h = g.sibling;

                  if (null !== h) {
                    h.return = g.return;
                    g = h;
                    break;
                  }

                  g = g.return;
                }
                h = g;
              }
            }

            ba(a, b, f.children, c);
            b = b.child;
          }

          return b;

        case 9:
          return f = b.type, e = b.pendingProps, d = e.children, ea(b, c), f = U(f, e.unstable_observedBits), d = d(f), b.effectTag |= 1, ba(a, b, d, c), b.child;

        case 14:
          return f = b.type, e = T(f, b.pendingProps), e = T(f.type, e), Ae(a, b, f, e, d, c);

        case 15:
          return Be(a, b, b.type, b.pendingProps, d, c);

        case 17:
          return d = b.type, f = b.pendingProps, f = b.elementType === d ? f : T(d, f), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, I(d) ? (a = !0, va(b)) : a = !1, ea(b, c), ie(b, d, f), Pc(b, d, f, c), jd(null, b, d, !0, a, c);

        case 19:
          return He(a, b, c);
      }

      throw Error(m(156, b.tag));
    };

    var Cc = {
      current: !1
    },
        Fd = null,
        sd = null,
        Ac = null,
        Jd = la.IsSomeRendererActing,
        yf = "function" === typeof X.unstable_flushAllWithoutAsserting,
        Gd = X.unstable_flushAllWithoutAsserting || function () {
      for (var a = !1; Za();) {
        a = !0;
      }

      return a;
    },
        Dc = 0,
        zf = !1,
        Kd = {
      __proto__: null,
      createContainer: function createContainer(a, b, c) {
        a = new Sg(a, b, c);
        b = ta(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
        a.current = b;
        b.stateNode = a;
        p(b);
        return a;
      },
      updateContainer: function updateContainer(a, b, c, d) {
        var f = b.current,
            e = pa(),
            g = Bb.suspense;
        e = Sa(e, f, g);

        a: if (c) {
          c = c._reactInternalFiber;

          b: {
            if (w(c) !== c || 1 !== c.tag) throw Error(m(170));
            var h = c;

            do {
              switch (h.tag) {
                case 3:
                  h = h.stateNode.context;
                  break b;

                case 1:
                  if (I(h.type)) {
                    h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                    break b;
                  }

              }

              h = h.return;
            } while (null !== h);

            throw Error(m(171));
          }

          if (1 === c.tag) {
            var p = c.type;

            if (I(p)) {
              c = Ga(c, p, h);
              break a;
            }
          }

          c = h;
        } else c = Fa;

        null === b.context ? b.context = c : b.pendingContext = c;
        b = oa(e, g);
        b.payload = {
          element: a
        };
        d = void 0 === d ? null : d;
        null !== d && (b.callback = d);
        F(f, b);
        ya(f, e);
        return e;
      },
      batchedEventUpdates: function batchedEventUpdates(a, b) {
        var c = x;
        x |= 2;

        try {
          return a(b);
        } finally {
          x = c, x === H && R();
        }
      },
      batchedUpdates: gf,
      unbatchedUpdates: function unbatchedUpdates(a, b) {
        var c = x;
        x &= -2;
        x |= zd;

        try {
          return a(b);
        } finally {
          x = c, x === H && R();
        }
      },
      deferredUpdates: function deferredUpdates(a) {
        return n(97, a);
      },
      syncUpdates: function syncUpdates(a, b, c, d) {
        return n(99, a.bind(null, b, c, d));
      },
      discreteUpdates: function discreteUpdates(a, b, c, d, f) {
        var e = x;
        x |= 4;

        try {
          return n(98, a.bind(null, b, c, d, f));
        } finally {
          x = e, x === H && R();
        }
      },
      flushDiscreteUpdates: function flushDiscreteUpdates() {
        (x & (1 | ka | qa)) === H && (Dg(), Za());
      },
      flushControlled: function flushControlled(a) {
        var b = x;
        x |= 1;

        try {
          n(99, a);
        } finally {
          x = b, x === H && R();
        }
      },
      flushSync: hf,
      flushPassiveEffects: Za,
      IsThisRendererActing: Cc,
      getPublicRootInstance: function getPublicRootInstance(a) {
        a = a.current;
        if (!a.child) return null;

        switch (a.child.tag) {
          case 5:
            return rd(a.child.stateNode);

          default:
            return a.child.stateNode;
        }
      },
      attemptSynchronousHydration: function attemptSynchronousHydration(a) {
        switch (a.tag) {
          case 3:
            var b = a.stateNode;
            b.hydrate && Cg(b, b.firstPendingTime);
            break;

          case 13:
            hf(function () {
              return ya(a, 1073741823);
            }), b = da(pa(), 150, 100), Bc(a, b);
        }
      },
      attemptUserBlockingHydration: function attemptUserBlockingHydration(a) {
        if (13 === a.tag) {
          var b = da(pa(), 150, 100);
          ya(a, b);
          Bc(a, b);
        }
      },
      attemptContinuousHydration: function attemptContinuousHydration(a) {
        13 === a.tag && (ya(a, 3), Bc(a, 3));
      },
      attemptHydrationAtCurrentPriority: function attemptHydrationAtCurrentPriority(a) {
        if (13 === a.tag) {
          var b = pa();
          b = Sa(b, a, null);
          ya(a, b);
          Bc(a, b);
        }
      },
      findHostInstance: mf,
      findHostInstanceWithWarning: function findHostInstanceWithWarning(a) {
        return mf(a);
      },
      findHostInstanceWithNoPortals: function findHostInstanceWithNoPortals(a) {
        a = Da(a);
        return null === a ? null : 20 === a.tag ? a.stateNode.instance : a.stateNode;
      },
      shouldSuspend: function shouldSuspend() {
        return !1;
      },
      injectIntoDevTools: function injectIntoDevTools(a) {
        var b = a.findFiberByHostInstance;
        return Og(rb({}, a, {
          overrideHookState: null,
          overrideProps: null,
          setSuspenseHandler: null,
          scheduleUpdate: null,
          currentDispatcherRef: la.ReactCurrentDispatcher,
          findHostInstanceByFiber: function findHostInstanceByFiber(a) {
            a = ma(a);
            return null === a ? null : a.stateNode;
          },
          findFiberByHostInstance: function findFiberByHostInstance(a) {
            return b ? b(a) : null;
          },
          findHostInstancesForRefresh: null,
          scheduleRefresh: null,
          scheduleRoot: null,
          setRefreshHandler: null,
          getCurrentFiber: null
        }));
      },
      act: function act(a) {
        function b() {
          Dc--;
          Jd.current = c;
          Cc.current = d;
        }

        !1 === zf && (zf = !0, console.error("act(...) is not supported in production builds of React, and might not behave as expected."));
        Dc++;
        var c = Jd.current,
            d = Cc.current;
        Jd.current = !0;
        Cc.current = !0;

        try {
          var f = gf(a);
        } catch (l) {
          throw b(), l;
        }

        if (null !== f && "object" === typeof f && "function" === typeof f.then) return {
          then: function then(a, d) {
            f.then(function () {
              1 < Dc || !0 === yf && !0 === c ? (b(), a()) : of(function (c) {
                b();
                c ? d(c) : a();
              });
            }, function (a) {
              b();
              d(a);
            });
          }
        };

        try {
          1 !== Dc || !1 !== yf && !1 !== c || Gd(), b();
        } catch (l) {
          throw b(), l;
        }

        return {
          then: function then(a) {
            a();
          }
        };
      }
    },
        Af = Kd && Kd["default"] || Kd;

    e.exports = Af.default || Af;
    var Wg = e.exports;
    e.exports = h;
    return Wg;
  };
});

var nb = new Map(),
    ob = {},
    L = {
  obj: function obj(e) {
    return e === Object(e) && !L.arr(e);
  },
  fun: function fun(e) {
    return "function" === typeof e;
  },
  str: function str(e) {
    return "string" === typeof e;
  },
  num: function num(e) {
    return "number" === typeof e;
  },
  und: function und(e) {
    return void 0 === e;
  },
  arr: function arr(e) {
    return Array.isArray(e);
  },
  equ: function equ(e, k) {
    if (typeof e !== typeof k || !!e !== !!k) return !1;
    if (L.str(e) || L.num(e) || L.obj(e)) return e === k;
    if (L.arr(e) && e == k) return !0;
    var g;

    for (g in e) {
      if (!(g in k)) return !1;
    }

    for (g in k) {
      if (e[g] !== k[g]) return !1;
    }

    return L.und(g) ? e === k : !0;
  }
};

function Ib(e, k) {
  var g = k.length;
  k.push(e);
  return function () {
    return void k.splice(g, 1);
  };
}

var Jb = [],
    Kb = [],
    Lb = [];

function Mb(e, k) {
  var g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var h = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
  var m;
  if (h) for (m = 0; m < Jb.length; m++) {
    Jb[m](k), g++;
  }
  var v = e.current.clock.getDelta();

  for (m = 0; m < e.current.subscribers.length; m++) {
    e.current.subscribers[m].ref.current(e.current, v);
  }

  e.current.frames = Math.max(0, e.current.frames - 1);
  g += e.current.invalidateFrameloop ? e.current.frames : 1;
  e.current.manual || e.current.gl.render(e.current.scene, e.current.camera);
  if (h) for (m = 0; m < Kb.length; m++) {
    Kb[m](k);
  }
  return g;
}

var Nb = !1;

function Ec(e) {
  Nb = !0;
  var k = 0,
      g;

  for (g = 0; g < Jb.length; g++) {
    Jb[g](e), k++;
  }

  nb.forEach(function (g) {
    g = g.containerInfo.__state;
    g.current.active && g.current.ready && (!g.current.invalidateFrameloop || 0 < g.current.frames) && (k = Mb(g, e, k));
  });

  for (g = 0; g < Kb.length; g++) {
    Kb[g](e);
  }

  if (0 !== k) return requestAnimationFrame(Ec);

  for (g = 0; g < Lb.length; g++) {
    Lb[g](e);
  }

  Nb = !1;
}

function Fc() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
  var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (!0 === e) nb.forEach(function (e) {
    return e.containerInfo.__state.current.frames = k;
  });else if (e && e.current) {
    if (e.current.vr) return;
    e.current.frames = k;
  }
  Nb || (Nb = !0, requestAnimationFrame(Ec));
}

var Gc = {};

function Ld(e, k) {
  var g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var h = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
  var m = e.__container;
  var v = [];
  var y = [];
  var r;
  var w = Object.keys(k);

  for (r = 0; r < w.length; r++) {
    L.equ(k[w[r]], g[w[r]]) && v.push(w[r]), L.fun(k[w[r]]) && w[r].startsWith("on") && (w[r].includes("Pointer") || w[r].includes("Click") || w[r].includes("ContextMenu") || w[r].includes("Wheel")) && y.push(w[r]);
  }

  var Q = [];
  w = Object.keys(g);
  if (h) for (r = 0; r < w.length; r++) {
    void 0 === k[w[r]] && Q.push(w[r]);
  }
  g = [].concat(_toConsumableArray(v), ["children", "key", "ref"]);
  e.__instance && g.push("object");
  v = _extends({}, k);
  w = Object.keys(v);

  for (r = 0; r < w.length; r++) {
    -1 < g.indexOf(w[r]) && delete v[w[r]];
  }

  w = Object.keys(Q);

  for (r = 0; r < w.length; r++) {
    "children" !== w[r] && (v[w[r]] = void 0);
  }

  r = Object.entries(v);
  0 < r.length && (r.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        g = _ref2[0],
        h = _ref2[1];

    if (!y.includes(g)) {
      var _w2;

      var k, m;
      var _v = e,
          _w = _v[g];

      if (g.includes("-")) {
        var r = g.split("-");
        _w = r.reduce(function (e, g) {
          return e[g];
        }, e);

        if (!_w || !_w.set) {
          var _r$reverse = r.reverse(),
              _r$reverse2 = _toArray(_r$reverse),
              _h = _r$reverse2[0],
              _k = _r$reverse2.slice(1);

          _v = _k.reverse().reduce(function (e, g) {
            return e[g];
          }, e);
          g = _h;
        }
      }

      r = null == (k = e.__container) ? void 0 : null == (m = k.__state) ? void 0 : m.current.colorManagement;
      _w && _w.set && (_w.copy || _w instanceof Layers) ? Array.isArray(h) ? (_w2 = _w).set.apply(_w2, _toConsumableArray(h)) : _w.copy && h && h.constructor && _w.constructor.name === h.constructor.name ? _w.copy(h) : void 0 !== h && (_w.set(h), r && _w instanceof Color && _w.convertSRGBToLinear()) : (_v[g] = h, r && _v[g] instanceof Texture && (_v[g].encoding = sRGBEncoding));
      Md(e);
    }
  }), h && m && e.raycast && e.__handlers && (e.__handlers = void 0, h = m.__interaction.indexOf(e), -1 < h && m.__interaction.splice(h, 1)), y.length && (m && e.raycast && m.__interaction.push(e), e.__handlers = y.reduce(function (e, g) {
    e[g.charAt(2).toLowerCase() + g.substr(3)] = k[g];
    return e;
  }, {})), e.parent && Nd(e));
}

function Md(e) {
  e.__container && e.__container.__state && Fc(e.__container.__state);
}

function Nd(e) {
  if (e.onUpdate) e.onUpdate(e);
}

function Od(e, k, g, h, m) {
  var _k2 = k;
  var _k2$args = _k2.args;
  h = _k2$args === void 0 ? [] : _k2$args;
  k = _objectWithoutPropertiesLoose(k, ["args"]);
  var v = "" + e[0].toUpperCase() + e.slice(1);
  if ("primitive" === e) k = _extends({
    dispose: null
  }, k), e = k.object, e.__instance = !0, e.__dispose = e.dispose;else if ("new" === e) e = new k.object(h);else {
    e = Gc[v] || THREE[v];
    if (!e) throw '"' + v + '" is not part of the THREE namespace! Did you forget to extend it? See: https://github.com/react-spring/react-three-fiber/blob/master/api.md#putting-already-existing-objects-into-the-scene-graph';
    e = L.arr(h) ? _construct(e, _toConsumableArray(h)) : new e(h);
  }

  for (; g.__container;) {
    g = g.__container;
  }

  if (!nb.has(g)) {
    var _e = function _e(g) {
      return g.return ? _e(g.return) : g.stateNode && g.stateNode.containerInfo;
    };

    g = _e(m);
  }

  e.__objects = [];
  e.__container = g;
  v.endsWith("Geometry") ? k = _extends({
    attach: "geometry"
  }, k) : v.endsWith("Material") && (k = _extends({
    attach: "material"
  }, k));
  Ld(e, k, {});
  return e;
}

function Pd(e, k) {
  k && (k.isObject3D ? e.add(k) : (e.__objects.push(k), k.parent = e, k.attachArray ? (L.arr(e[k.attachArray]) || (e[k.attachArray] = []), e[k.attachArray].push(k)) : k.attachObject ? (L.obj(e[k.attachObject[0]]) || (e[k.attachObject[0]] = {}), e[k.attachObject[0]][k.attachObject[1]] = k) : k.attach && (e[k.attach] = k)), Nd(k), Md(k));
}

function Qd(e, k, g) {
  if (k) {
    if (k.isObject3D) {
      k.parent = e;
      k.dispatchEvent({
        type: "added"
      });
      var h = e.children.filter(function (e) {
        return e !== k;
      });
      g = h.indexOf(g);
      e.children = [].concat(_toConsumableArray(h.slice(0, g)), [k], _toConsumableArray(h.slice(g)));
      Nd(k);
    } else Pd(e, k);

    Md(k);
  }
}

function Rd(e, k) {
  var g = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  e && (g ? _toConsumableArray(e) : e).forEach(function (e) {
    return Sd(k, e);
  });
}

function Sd(e, k) {
  k && (k.isObject3D ? e.remove(k) : (k.parent = null, e.__objects && (e.__objects = e.__objects.filter(function (e) {
    return e !== k;
  })), k.attachArray ? e[k.attachArray] = e[k.attachArray].filter(function (e) {
    return e !== k;
  }) : k.attachObject ? delete e[k.attachObject[0]][k.attachObject[1]] : k.attach && (e[k.attach] = null)), Md(k), null !== k.dispose && unstable_runWithPriority(unstable_IdlePriority, function () {
    k.__container && (k.__container.__interaction = k.__container.__interaction.filter(function (e) {
      return e !== k;
    }));
    Rd(k.__objects, k);
    Rd(k.children, k, !0);
    k.dispose ? k.dispose() : k.__dispose && k.__dispose();
    delete k.__container;
    delete k.__objects;
  }));
}

function Bf(e, k, g, h) {
  var m = e.parent,
      v = Od(k, g, e.__container, null, h);
  Sd(m, e);
  Pd(m, v);
  [h, h.alternate].forEach(function (e) {
    null !== e && (e.stateNode = v, e.ref && (L.fun(e.ref) ? e.ref(v) : e.ref.current = v));
  });
}

var Cf = Ma({
  now: unstable_now,
  createInstance: Od,
  removeChild: Sd,
  appendChild: Pd,
  insertBefore: Qd,
  warnsIfNotActing: !0,
  supportsMutation: !0,
  isPrimaryRenderer: !1,
  scheduleTimeout: L.fun(setTimeout) ? setTimeout : void 0,
  cancelTimeout: L.fun(clearTimeout) ? clearTimeout : void 0,
  setTimeout: L.fun(setTimeout) ? setTimeout : void 0,
  clearTimeout: L.fun(clearTimeout) ? clearTimeout : void 0,
  noTimeout: -1,
  appendInitialChild: Pd,
  appendChildToContainer: Pd,
  removeChildFromContainer: Sd,
  insertInContainerBefore: Qd,
  commitUpdate: function commitUpdate(e, k, g, h, m, v) {
    if (e.__instance && m.object && m.object !== e) Bf(e, g, m, v);else {
      var _m$args = m.args;
      k = _m$args === void 0 ? [] : _m$args;

      var y = _objectWithoutPropertiesLoose(m, ["args"]),
          _h2 = h,
          _h2$args = _h2.args,
          r = _h2$args === void 0 ? [] : _h2$args;

      h = _objectWithoutPropertiesLoose(h, ["args"]);
      k.some(function (e, g) {
        return L.obj(e) ? Object.entries(e).some(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              e = _ref4[0],
              h = _ref4[1];

          return h !== r[g][e];
        }) : e !== r[g];
      }) ? Bf(e, g, m, v) : Ld(e, y, h, !0);
    }
  },
  hideInstance: function hideInstance(e) {
    e.isObject3D && (e.visible = !1, Md(e));
  },
  unhideInstance: function unhideInstance(e, k) {
    if (e.isObject3D && null == k.visible || k.visible) e.visible = !0, Md(e);
  },
  hideTextInstance: function hideTextInstance() {
    throw Error("Text is not allowed in the react-three-fibre tree. You may have extraneous whitespace between components.");
  },
  getPublicInstance: function getPublicInstance(e) {
    return e;
  },
  getRootHostContext: function getRootHostContext() {
    return ob;
  },
  getChildHostContext: function getChildHostContext() {
    return ob;
  },
  createTextInstance: function createTextInstance() {},
  finalizeInitialChildren: function finalizeInitialChildren() {
    return !1;
  },
  prepareUpdate: function prepareUpdate() {
    return ob;
  },
  shouldDeprioritizeSubtree: function shouldDeprioritizeSubtree() {
    return !1;
  },
  prepareForCommit: function prepareForCommit() {
    return null;
  },
  preparePortalMount: function preparePortalMount() {
    return null;
  },
  resetAfterCommit: function resetAfterCommit() {},
  shouldSetTextContent: function shouldSetTextContent() {
    return !1;
  },
  clearContainer: function clearContainer() {
    return !1;
  }
}),
    Df = L.fun(Symbol) && Symbol.for ? Symbol.for("react.portal") : 60106;

function Ef(e, k, g) {
  var h = nb.get(k);
  h || (k.__state = g, g = h = Cf.createContainer(k, void 0 !== g && g.current.concurrent ? 2 : 0, !1, null), nb.set(k, g));
  Cf.updateContainer(e, h, null, function () {});
  return Cf.getPublicRootInstance(h);
}

function Ff(e, k) {
  var g = nb.get(e);
  g && Cf.updateContainer(null, g, null, function () {
    nb.delete(e);
    k && k(e);
  });
}

Cf.injectIntoDevTools({
  bundleType: "production" === process.env.NODE_ENV ? 0 : 1,
  findHostInstanceByFiber: function findHostInstanceByFiber() {
    return null;
  },
  version: React.version,
  rendererPackageName: "react-three-fiber"
});

function Gf(e) {
  return (e.eventObject || e.object).uuid + "/" + e.index;
}

var Hf = createContext({}),
    Jf = function Jf(e) {
  var _e2 = e,
      k = _e2.children,
      g = _e2.gl,
      h = _e2.camera,
      m = _e2.orthographic,
      v = _e2.raycaster,
      y = _e2.size,
      r = _e2.pixelRatio,
      _e2$vr = _e2.vr,
      w = _e2$vr === void 0 ? !1 : _e2$vr,
      _e2$concurrent = _e2.concurrent,
      Q = _e2$concurrent === void 0 ? !1 : _e2$concurrent,
      _e2$shadowMap = _e2.shadowMap,
      M = _e2$shadowMap === void 0 ? !1 : _e2$shadowMap,
      _e2$colorManagement = _e2.colorManagement,
      ma = _e2$colorManagement === void 0 ? !0 : _e2$colorManagement,
      _e2$invalidateFramelo = _e2.invalidateFrameloop,
      Da = _e2$invalidateFramelo === void 0 ? !1 : _e2$invalidateFramelo,
      _e2$updateDefaultCame = _e2.updateDefaultCamera,
      Ea = _e2$updateDefaultCame === void 0 ? !0 : _e2$updateDefaultCame,
      _e2$noEvents = _e2.noEvents,
      A = _e2$noEvents === void 0 ? !1 : _e2$noEvents,
      B = _e2.onCreated,
      Z = _e2.onPointerMissed,
      I = _e2.forceResize,
      _useState = useState(!1),
      _useState2 = _slicedToArray(_useState, 2),
      na = _useState2[0],
      qb = _useState2[1],
      _useState3 = useState(function () {
    return new Vector2();
  }),
      _useState4 = _slicedToArray(_useState3, 1),
      Ga = _useState4[0],
      _useState5 = useState(function () {
    var e = new Raycaster();

    if (v) {
      var _g = _objectWithoutPropertiesLoose(v, ["filter"]);

      Ld(e, _g, {});
    }

    return e;
  }),
      _useState6 = _slicedToArray(_useState5, 1),
      va = _useState6[0],
      _useState7 = useState(function () {
    var e = new Scene();
    e.__interaction = [];
    e.__objects = [];
    return e;
  }),
      _useState8 = _slicedToArray(_useState7, 1),
      sb = _useState8[0],
      _useState9 = useState(function () {
    var e = m ? new OrthographicCamera(0, 0, 0, 0, .1, 1E3) : new PerspectiveCamera(75, 0, .1, 1E3);
    e.position.z = 5;
    h && Ld(e, h, {});
    e.lookAt(0, 0, 0);
    return e;
  }),
      _useState10 = _slicedToArray(_useState9, 2),
      J = _useState10[0],
      Rb = _useState10[1];

  var _useState11 = useState(function () {
    return new Clock();
  });

  var _useState12 = _slicedToArray(_useState11, 1);

  e = _useState12[0];
  var n = useRef({
    ready: !1,
    active: !0,
    manual: 0,
    colorManagement: ma,
    vr: w,
    concurrent: Q,
    noEvents: A,
    invalidateFrameloop: !1,
    frames: 0,
    aspect: 0,
    subscribers: [],
    camera: J,
    scene: sb,
    raycaster: va,
    mouse: Ga,
    clock: e,
    gl: g,
    size: y,
    viewport: null,
    initialClick: [0, 0],
    initialHits: [],
    pointer: new TinyEmitter(),
    captured: void 0,
    events: void 0,
    subscribe: function subscribe(e) {
      var g = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      g && n.current.manual++;
      n.current.subscribers.push({
        ref: e,
        priority: g
      });
      n.current.subscribers = n.current.subscribers.sort(function (e, g) {
        return e.priority - g.priority;
      });
      return function () {
        var h;
        if (null == (h = n.current) ? 0 : h.subscribers) g && n.current.manual--, n.current.subscribers = n.current.subscribers.filter(function (g) {
          return g.ref !== e;
        });
      };
    },
    setDefaultCamera: function setDefaultCamera(e) {
      return Rb(e);
    },
    invalidate: function invalidate() {
      return Fc(n);
    },
    intersect: function intersect() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var g = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      return fb(e, g);
    },
    forceResize: I
  }),
      tb = useCallback(function () {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : n.current.camera;
    var g = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3(0, 0, 0);
    var _n$current$size = n.current.size,
        h = _n$current$size.width,
        p = _n$current$size.height;
    g = e.position.distanceTo(g);
    if (e.isOrthographicCamera) return {
      width: h / e.zoom,
      height: p / e.zoom,
      factor: 1,
      distance: g
    };
    {
      e = 2 * Math.tan(e.fov * Math.PI / 180 / 2) * g;

      var _k3 = h / p * e;

      return {
        width: _k3,
        height: e,
        factor: h / _k3,
        distance: g
      };
    }
  }, []);
  useMemo(function () {
    n.current.ready = na;
    n.current.size = y;
    n.current.camera = J;
    n.current.invalidateFrameloop = Da;
    n.current.vr = w;
    n.current.gl = g;
    n.current.concurrent = Q;
    n.current.noEvents = A;
    n.current.viewport = tb;
  }, [Da, w, Q, A, na, y, J, g]);
  useMemo(function () {
    n.current.aspect = y.width / y.height;
    Object.assign(n.current.viewport, tb());
    Ea && (J.isOrthographicCamera ? (J.left = y.width / -2, J.right = y.width / 2, J.top = y.height / 2, J.bottom = y.height / -2) : J.aspect = n.current.aspect, J.updateProjectionMatrix(), J.updateMatrixWorld());
    g.setSize(y.width, y.height);
    na && Fc(n);
  }, [J, g, y, Ea]);
  var cb = useCallback(function (_ref5) {
    var e = _ref5.nativeEvent;

    if (void 0 !== e) {
      var _g2 = e.offsetX,
          _h3 = e.offsetY,
          _n$current$size2 = n.current.size,
          _k4 = _n$current$size2.width,
          p = _n$current$size2.height;
      Ga.set(_g2 / _k4 * 2 - 1, 2 * -(_h3 / p) + 1);
      va.setFromCamera(Ga, n.current.camera);
    }
  }, []),
      R = useCallback(function (e, g) {
    if (n.current.noEvents) return [];
    var h = new Set();
    e = [];
    g = g ? g(n.current.scene.__interaction) : n.current.scene.__interaction;
    g = va.intersectObjects(g, !0).filter(function (e) {
      e = Gf(e);
      if (h.has(e)) return !1;
      h.add(e);
      return !0;
    });
    v && v.filter && ea.current && (g = v.filter(g, ea.current));

    var _iterator = _createForOfIteratorHelper(g),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _h4 = _step.value;

        for (g = _h4.object; g;) {
          g.__handlers && e.push(_extends({}, _h4, {
            eventObject: g
          })), g = g.parent;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return e;
  }, []),
      ub = useCallback(function (e) {
    var g = e.nativeEvent.offsetX - n.current.initialClick[0];
    e = e.nativeEvent.offsetY - n.current.initialClick[1];
    return Math.round(Math.sqrt(g * g + e * e));
  }, []),
      da = useMemo(function () {
    return new Map();
  }, []),
      db = useCallback(function (e, g) {
    var h = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
    n.current.pointer.emit("pointerCancel", e);
    h && cb(e);
    Array.from(da.values()).forEach(function (e) {
      if (g && (!g.length || !g.find(function (g) {
        return g.eventObject === e.eventObject;
      }))) {
        var _g3 = e.eventObject.__handlers;
        _g3 && (_g3.pointerOut && _g3.pointerOut(_extends({}, e, {
          type: "pointerout"
        })), _g3.pointerLeave && _g3.pointerLeave(_extends({}, e, {
          type: "pointerleave"
        })));
        da.delete(Gf(e));
      }
    });
  }, []),
      eb = new Vector3(),
      T = useCallback(function (e, g) {
    var h = R(e, g);
    n.current.captured && "click" !== e.type && "wheel" !== e.type && n.current.captured.forEach(function (e) {
      h.find(function (g) {
        return g.eventObject === e.eventObject;
      }) || h.push(e);
    });
    return h;
  }, []),
      vb = useCallback(function (e, g, h) {
    if (e.length) {
      var p = eb.set(Ga.x, Ga.y, 0).unproject(n.current.camera),
          _r = "click" === g.type ? ub(g) : 0,
          t = function t(e) {
        return g.target.releasePointerCapture(e);
      };

      var k = !1,
          m = !1;

      var _iterator2 = _createForOfIteratorHelper(e),
          _step2;

      try {
        var _loop = function _loop() {
          var w = _step2.value;

          var v = function v(e) {
            m || (m = !0, n.current.captured = []);
            n.current.captured && n.current.captured.push(w);
            g.target.setPointerCapture(e);
          },
              y = _extends({}, g, w, {
            intersections: e,
            stopped: k,
            delta: _r,
            unprojectedPoint: p,
            ray: va.ray,
            camera: n.current.camera,
            stopPropagation: function stopPropagation() {
              var e = n.current.captured;
              if (!e || e.find(function (e) {
                return e.eventObject.id === w.eventObject.id;
              })) y.stopped = k = !0;
            },
            target: _extends({}, g.target, {
              setPointerCapture: v,
              releasePointerCapture: t
            }),
            currentTarget: _extends({}, g.currentTarget, {
              setPointerCapture: v,
              releasePointerCapture: t
            }),
            sourceEvent: g
          });

          h(y);

          if (!0 === k) {
            da.size && Array.from(da.values()).find(function (e) {
              return e.object === w.object;
            }) && db(y, [w]);
            return "break";
          }
        };

        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _ret = _loop();

          if (_ret === "break") break;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    return e;
  }, []),
      fb = useCallback(function (e) {
    var g = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
    n.current.pointer.emit("pointerMove", e);
    g && cb(e);
    var h = T(e, function (e) {
      return e.filter(function (e) {
        return ["Move", "Over", "Enter", "Out", "Leave"].some(function (g) {
          return e.__handlers["pointer" + g];
        });
      });
    });
    db(e, h, g);
    vb(h, e, function (e) {
      var g = e.eventObject.__handlers;

      if (g) {
        if (g.pointerOver || g.pointerEnter || g.pointerOut || g.pointerLeave) {
          var _h5 = Gf(e),
              _k5 = da.get(_h5);

          _k5 ? _k5.stopped && e.stopPropagation() : (da.set(_h5, e), g.pointerOver && g.pointerOver(_extends({}, e, {
            type: "pointerover"
          })), g.pointerEnter && g.pointerEnter(_extends({}, e, {
            type: "pointerenter"
          })));
        }

        g.pointerMove && g.pointerMove(e);
      }
    });
    return h;
  }, []),
      xa = useCallback(function (e) {
    return function (g) {
      var h = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      n.current.pointer.emit(e, g);
      h && cb(g);
      h = T(g);
      vb(h, g, function (g) {
        var h = g.eventObject,
            k = h.__handlers;
        if (k && k[e] && ("click" !== e && "contextMenu" !== e && "doubleClick" !== e || n.current.initialHits.includes(h))) k[e](g);
      });
      "pointerDown" === e && (n.current.initialClick = [g.nativeEvent.offsetX, g.nativeEvent.offsetY], n.current.initialHits = h.map(function (e) {
        return e.eventObject;
      }));
      "click" !== e && "contextMenu" !== e && "doubleClick" !== e || h.length || !Z || 2 >= ub(g) && Z();
    };
  }, [Z]);
  useMemo(function () {
    n.current.events = {
      onClick: xa("click"),
      onContextMenu: xa("contextMenu"),
      onDoubleClick: xa("doubleClick"),
      onWheel: xa("wheel"),
      onPointerDown: xa("pointerDown"),
      onPointerUp: xa("pointerUp"),
      onPointerLeave: function onPointerLeave(e) {
        return db(e, []);
      },
      onPointerMove: fb,
      onGotPointerCaptureLegacy: function onGotPointerCaptureLegacy(e) {
        return n.current.captured = R(e);
      },
      onLostPointerCapture: function onLostPointerCapture(e) {
        return n.current.captured = void 0, db(e);
      }
    };
  }, [Z]);
  var ea = useRef();
  useMemo(function () {
    var e = _objectWithoutPropertiesLoose(n.current, "ready manual vr noEvents invalidateFrameloop frames subscribers captured initialClick initialHits".split(" "));

    ea.current = e;
  }, [y, J]);
  useLayoutEffect(function () {
    r && (Array.isArray(r) ? g.setPixelRatio(Math.max(Math.min(r[0], window.devicePixelRatio), r[1])) : g.setPixelRatio(r));
  }, [g, r]);
  useLayoutEffect(function () {
    M && (g.shadowMap.enabled = !0, "object" === typeof M ? Object.assign(g.shadowMap, M) : g.shadowMap.type = PCFSoftShadowMap);
    ma && (g.toneMapping = ACESFilmicToneMapping, g.outputEncoding = sRGBEncoding);
  }, [M, ma]);
  var U = useCallback(function (e) {
    var g = function g() {
      return qb(!0);
    };

    useEffect(function () {
      var e = B && B(n.current);
      return void (e && e.then ? e.then(g) : qb(!0));
    }, []);
    return e.children;
  }, []);
  useLayoutEffect(function () {
    Ef(React.createElement(U, null, React.createElement(Hf.Provider, {
      value: ea.current
    }, "function" === typeof k ? k(n.current) : k)), sb, n);
  }, [na, k, ea.current]);
  useLayoutEffect(function () {
    na && (n.current.vr ? (g.xr || g.vr) && g.setAnimationLoop ? ((g.xr || g.vr).enabled = !0, g.setAnimationLoop(function (e) {
      return Mb(n, e, 0, !0);
    })) : console.warn("the gl instance does not support VR!") : Fc(n));
  }, [na, Da]);
  useEffect(function () {
    return function () {
      n.current.gl && (n.current.gl.renderLists.dispose(), n.current.gl.forceContextLoss && n.current.gl.forceContextLoss(), If(n.current.gl));
      Ff(n.current.scene, function () {
        If(n.current.raycaster);
        If(n.current.camera);
        If(n.current);
      });
    };
  }, []);
  return n.current.events;
};

function If(e) {
  e.dispose && e.dispose();

  for (var k in e) {
    "object" === typeof k && k.dispose && k.dispose(), delete e[k];
  }
}

function Kf(e) {
  (e = useContext$1(e)) || console.warn("hooks can only be used within the canvas! https://github.com/react-spring/react-three-fiber#hooks");
  return e;
}

function Lf(e, k) {
  return function (g, h) {
    var m = new g();
    e && e(m);
    g = Array.isArray(h) ? h : [h];
    return Promise.all(g.map(function (e) {
      return new Promise(function (g, h) {
        return m.load(e, function (e) {
          e.scene && (e.nodes = {}, e.materials = {}, e.scene.traverse(function (g) {
            g.name && (e.nodes[g.name] = g);
            g.material && !e.materials[g.material.name] && (e.materials[g.material.name] = g.material);
          }));
          g(e);
        }, k, function (e) {
          return h(e.message);
        });
      });
    }));
  };
}

function Xg(e, k, g, h) {
  e = useAsset(Lf(g, h), [e, k]);
  return Array.isArray(k) ? e : e[0];
}

Xg.preload = function (e, k, g) {
  return useAsset.preload(Lf(g), e, k);
};

var Yg = {
  position: "relative",
  width: "100%",
  height: "100%",
  overflow: "hidden"
};

function Zg(e) {
  var _e3 = e,
      k = _e3.children,
      g = _e3.setEvents,
      h = _e3.container,
      m = _e3.renderer,
      v = _e3.effects;
  e = _objectWithoutPropertiesLoose(e, ["children", "setEvents", "container", "renderer", "effects"]);

  var _useState13 = useState(m),
      _useState14 = _slicedToArray(_useState13, 1),
      y = _useState14[0];

  y || console.warn("No renderer created!");
  useEffect(function () {
    v && v(y, h);
  }, [h, v, y]);
  var r = Jf(_extends({}, e, {
    children: k,
    gl: y
  }));
  useEffect(function () {
    g(r);
  }, [r, g]);
  return null;
}

var $g = React.memo(function (e) {
  var k = e.preRender,
      g = e.resize,
      h = e.style,
      m = _objectWithoutPropertiesLoose(e, "renderer effects children vr webgl1 concurrent shadowMap colorManagement orthographic invalidateFrameloop updateDefaultCamera noEvents gl camera raycaster pixelRatio onCreated onPointerMissed preRender resize style".split(" ")),
      v = useRef(),
      _useState15 = useState({}),
      _useState16 = _slicedToArray(_useState15, 2),
      y = _useState16[0],
      r = _useState16[1],
      w = _objectWithoutPropertiesLoose(y, ["onGotPointerCaptureLegacy"]),
      _useMeasure = useMeasure(g || {
    scroll: !1,
    debounce: {
      scroll: 50,
      resize: 0
    },
    polyfill: "undefined" !== typeof window && window.ResizeObserver ? void 0 : ResizeObserver
  }),
      _useMeasure2 = _slicedToArray(_useMeasure, 3),
      Q = _useMeasure2[0],
      M = _useMeasure2[1],
      ma = _useMeasure2[2],
      Da = useRef(!1),
      Ea = useMemo(function () {
    return Da.current = Da.current || !!M.width && !!M.height;
  }, [M]),
      A = useMemo(function () {
    return {
      size: M,
      forceResize: ma,
      setEvents: r,
      container: v.current
    };
  }, [ma, M]);

  return "undefined" === typeof window ? React.createElement("div", _extends({
    style: _extends({}, Yg, h)
  }, m), k) : React.createElement("div", _extends({
    ref: mergeRefs([Q, v]),
    style: _extends({}, Yg, h)
  }, w, m), k, Ea && React.createElement(Zg, _extends({}, e, A)));
}),
    ah = React.memo(function (e) {
  var k = e.children,
      g = _objectWithoutPropertiesLoose(e, ["children"]);

  var h = useRef(),
      m = g.webgl1 ? WebGL1Renderer : WebGLRenderer;
  return React.createElement($g, _extends({}, g, {
    renderer: function renderer() {
      if (h.current) {
        var _e4 = _extends({
          antialias: !0,
          alpha: !0
        }, g.gl);

        return new m(_extends({
          powerPreference: "high-performance",
          canvas: h.current
        }, _e4));
      }
    },
    preRender: React.createElement("canvas", {
      ref: h,
      style: {
        display: "block"
      }
    })
  }), k);
});

var addAfterEffect = function addAfterEffect(e) {
  return Ib(e, Kb);
};

var addEffect = function addEffect(e) {
  return Ib(e, Jb);
};

var addTail = function addTail(e) {
  return Ib(e, Lb);
};

function createPortal(e, k, g) {
  var h = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  k.__objects || (k.__objects = []);
  return {
    $$typeof: Df,
    key: null == h ? null : "" + h,
    children: e,
    containerInfo: k,
    implementation: g
  };
}

;

var extend = function extend(e) {
  return void (Gc = _extends({}, Gc, e));
};

function forceResize() {
  nb.forEach(function (e) {
    return e.containerInfo.__state.current.forceResize();
  });
}

;

function isOrthographicCamera(e) {
  return e.isOrthographicCamera;
}

;

function useFrame(e) {
  var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var _Kf = Kf(Hf),
      g = _Kf.subscribe,
      h = useRef(e);

  useLayoutEffect(function () {
    return void (h.current = e);
  }, [e]);
  useEffect(function () {
    var e = g(h, k);
    return function () {
      return e();
    };
  }, [k, g]);
  return null;
}

;

function useResource(e) {
  var _useState17 = useState(!1),
      _useState18 = _slicedToArray(_useState17, 2),
      k = _useState18[1],
      g = useRef(void 0);

  e = e ? e : g;
  useLayoutEffect(function () {
    return void k(function (e) {
      return !e;
    });
  }, []);
  return e;
}

;

function useThree() {
  return Kf(Hf);
}

;

function useUpdate(e, k, g) {
  var _Kf2 = Kf(Hf),
      h = _Kf2.invalidate,
      m = useRef(),
      v = g ? g : m;

  useLayoutEffect(function () {
    v.current && (e(v.current), h());
  }, k);
  return v;
}

;
export { ah as Canvas, Cf as Renderer, addAfterEffect, addEffect, addTail, Ld as applyProps, createPortal, extend, forceResize, Fc as invalidate, isOrthographicCamera, Ef as render, Mb as renderGl, Hf as stateContext, Ff as unmountComponentAtNode, Jf as useCanvas, useFrame, Xg as useLoader, useResource, useThree, useUpdate };